/* Outdoors Nordic — size quiz engine
 * Vanilla JS, no dependencies, no build step.
 *
 * Boot:  OnSizeQuiz.init(config)   // see on-size-quiz.liquid for the config shape
 * Events: document dispatches "on:size-quiz:result" with { size, alternative, measurements }
 *
 * The body profile is stored once in localStorage. Every product recalculates its own
 * recommendation from that profile against its own size chart, so a shopper answers
 * the questions one time and gets a size on all 17 products.
 */
(function (window, document) {
  'use strict';

  /* EN uppsattning per sida. Temaeditorn lagger in skripttaggen pa nytt vid
     varje installningsandring, och utan den har spärren byts window.OnSizeQuiz
     ut mot ett nytt objekt vars instance ar null - medan den gamla panelen
     ligger kvar i body. Samma monster som on-fbt.js redan anvander. */
  if (window.OnSizeQuiz) return;

  var STORAGE_KEY = 'on_sq_body_v2';

  /* ------------------------------------------------------------------ *
   * Fallback copy. The Liquid snippet overrides all of this with        *
   * Shopify translations so the quiz works in all 12 markets.           *
   * ------------------------------------------------------------------ */
  var SV = {
    trigger: 'Hitta din storlek',
    trigger_known: 'Din storlek: {size}',
    brand: 'OUTDOORS NORDIC',
    close: 'Stäng',
    intro_title: 'Rätt storlek första gången',
    intro_body: 'Svara på sex frågor så räknar vi ut vilken storlek som sitter bäst på just dig.',
    strip: 'Klart på 30 sekunder',
    back_to_top: 'Till toppen',
    privacy: 'Integritetspolicy',
    next: 'Nästa',
    done: 'Visa min storlek',
    height: 'Längd',
    height_q: 'Hur lång är du?',
    height_value: 'Jag är {value}',
    weight: 'Vikt',
    weight_q: 'Vad väger du?',
    weight_value: 'Jag väger {value}',
    age: 'Ålder',
    age_q: 'Hur gammal är du?',
    age_help: 'Kroppen ändrar form med åren. Det påverkar vilken storlek som sitter bäst.',
    age_value: 'Jag är {value}',
    waist: 'Midja',
    waist_q: 'Hur ser din midja ut?',
    waist_flat: 'Platt',
    waist_average: 'Genomsnittlig',
    waist_round: 'Rund',
    hips: 'Höfter',
    hips_q: 'Hur ser dina höfter ut?',
    hips_narrow: 'Smala',
    hips_average: 'Genomsnittliga',
    hips_wide: 'Bredare',
    legs: 'Ben',
    legs_q: 'Hur är dina ben jämfört med andra som är lika långa?',
    legs_short: 'Kortare',
    legs_average: 'Som de flesta',
    legs_long: 'Längre',
    bust: 'Byst',
    bust_q: 'Hur ser din byst ut?',
    bust_small: 'Liten',
    bust_average: 'Genomsnittlig',
    bust_full: 'Fylligare',
    fit: 'Passform',
    fit_q: 'Hur vill du att plagget sitter?',
    fit_tight: 'Tajtare',
    fit_regular: 'Som vanligt',
    fit_loose: 'Lösare',
    result_title: 'Din storlek',
    result_sub: 'Vi sparar svaren så du får storleksråd på alla plagg.',
    result_for: 'För den här produkten rekommenderar vi',
    out_of_range: 'Den här modellen räcker inte hela vägen till dina mått. Hör av dig så hjälper vi dig hitta en som gör det.',
    contact_link: 'Kontakta oss',
    color: 'Färg',
    pick_size: 'Välj {size}',
    add: 'Lägg {size} i varukorgen',
    sold_out: 'Slut i {size}',
    adding: 'Lägger till ...',
    added: 'Tillagd i varukorgen',
    cart_error: 'Det gick inte att lägga varan i varukorgen. Försök igen.',
    restart: 'Gör om quizet',
    size_guide: 'Se hela storleksguiden',
    cm: 'cm', ft: 'ft', kg: 'kg', lb: 'lb',
    note: 'Rätt storlek från början betyder färre returer. Det tjänar du på, och miljön med.'
  };

  /* ------------------------------------------------------------------ *
   * Figures                                                             *
   * ------------------------------------------------------------------ */
  /* Figurerna ritas symmetriskt ur nagra breddvarden i stallet for handritade
     halvkroppar. Poangen ar att man ska SE vilket matt fragan galler: kroppen
     ar likadan i alla tre alternativen, det enda som andras ar bredden pa den
     niva fragan handlar om, och dar ligger ett markerat matband. */
  var FIG_W = 100;
  var FIG_H = 150;
  var FIG_Y = { shoulder: 30, bust: 52, waist: 80, hip: 106, hem: 142 };

  var FIG_SHAPES = {
    waist: {
      level: 'waist',
      flat: { shoulder: 40, bust: 36, waist: 26, hip: 40 },
      average: { shoulder: 40, bust: 36, waist: 31, hip: 40 },
      round: { shoulder: 40, bust: 37, waist: 38, hip: 41 }
    },
    hips: {
      level: 'hip',
      narrow: { shoulder: 40, bust: 36, waist: 30, hip: 34 },
      average: { shoulder: 40, bust: 36, waist: 30, hip: 41 },
      wide: { shoulder: 40, bust: 36, waist: 31, hip: 49 }
    },
    bust: {
      level: 'bust',
      small: { shoulder: 38, bust: 31, waist: 30, hip: 40 },
      average: { shoulder: 40, bust: 36, waist: 30, hip: 40 },
      full: { shoulder: 41, bust: 43, waist: 31, hip: 40 }
    }
  };

  function figPath(w) {
    var cx = FIG_W / 2;
    var y = FIG_Y;
    var sh = w.shoulder / 2, bu = w.bust / 2, wa = w.waist / 2, hi = w.hip / 2;
    var hemHalf = hi - 3;
    var p = [];
    p.push('M' + (cx - sh) + ' ' + y.shoulder);
    p.push('C' + (cx - bu - 1) + ' ' + (y.shoulder + 8) + ' ' + (cx - bu) + ' ' + (y.bust - 8) + ' ' + (cx - bu) + ' ' + y.bust);
    p.push('C' + (cx - bu) + ' ' + (y.bust + 11) + ' ' + (cx - wa) + ' ' + (y.waist - 11) + ' ' + (cx - wa) + ' ' + y.waist);
    p.push('C' + (cx - wa) + ' ' + (y.waist + 11) + ' ' + (cx - hi) + ' ' + (y.hip - 13) + ' ' + (cx - hi) + ' ' + y.hip);
    p.push('C' + (cx - hi) + ' ' + (y.hip + 16) + ' ' + (cx - hemHalf) + ' ' + (y.hem - 12) + ' ' + (cx - hemHalf) + ' ' + y.hem);
    p.push('L' + (cx + hemHalf) + ' ' + y.hem);
    p.push('C' + (cx + hemHalf) + ' ' + (y.hem - 12) + ' ' + (cx + hi) + ' ' + (y.hip + 16) + ' ' + (cx + hi) + ' ' + y.hip);
    p.push('C' + (cx + hi) + ' ' + (y.hip - 13) + ' ' + (cx + wa) + ' ' + (y.waist + 11) + ' ' + (cx + wa) + ' ' + y.waist);
    p.push('C' + (cx + wa) + ' ' + (y.waist - 11) + ' ' + (cx + bu) + ' ' + (y.bust + 11) + ' ' + (cx + bu) + ' ' + y.bust);
    p.push('C' + (cx + bu) + ' ' + (y.bust - 8) + ' ' + (cx + sh + 1) + ' ' + (y.shoulder + 8) + ' ' + (cx + sh) + ' ' + y.shoulder);
    p.push('Z');
    return p.join('');
  }

  /* Benfiguren ritas for sig: har ar det inte bredden pa en niva som andras utan
     benens LANGD, och matbandet ligger langs innerbenet i stallet for runt kroppen. */
  var FIG_LEG_HEM = { short: 126, average: 136, long: 146 };

  function figureLegs(key) {
    var cx = FIG_W / 2;
    var y = FIG_Y;
    var hem = FIG_LEG_HEM[key] || FIG_LEG_HEM.average;
    var w = { shoulder: 40, bust: 36, waist: 30, hip: 40 };
    var sh = w.shoulder / 2, bu = w.bust / 2, wa = w.waist / 2, hi = w.hip / 2;
    var crotch = y.hip + 10;
    var gap = 3, ankle = 5;

    var out = '<svg viewBox="0 0 ' + FIG_W + ' ' + FIG_H + '" aria-hidden="true" focusable="false">';
    out += '<circle class="on-sq-fig-line" cx="' + cx + '" cy="14" r="9"/>';
    out += '<path class="on-sq-fig-line" d="M' + (cx - 5) + ' 23 L' + (cx - 5) + ' 30 M' + (cx + 5) + ' 23 L' + (cx + 5) + ' 30"/>';
    // bal ner till grenen
    var t = 'M' + (cx - sh) + ' ' + y.shoulder +
      'C' + (cx - bu - 1) + ' ' + (y.shoulder + 8) + ' ' + (cx - bu) + ' ' + (y.bust - 8) + ' ' + (cx - bu) + ' ' + y.bust +
      'C' + (cx - bu) + ' ' + (y.bust + 11) + ' ' + (cx - wa) + ' ' + (y.waist - 11) + ' ' + (cx - wa) + ' ' + y.waist +
      'C' + (cx - wa) + ' ' + (y.waist + 11) + ' ' + (cx - hi) + ' ' + (y.hip - 13) + ' ' + (cx - hi) + ' ' + y.hip +
      'L' + (cx - hi) + ' ' + crotch + 'L' + (cx + hi) + ' ' + crotch + 'L' + (cx + hi) + ' ' + y.hip +
      'C' + (cx + hi) + ' ' + (y.hip - 13) + ' ' + (cx + wa) + ' ' + (y.waist + 11) + ' ' + (cx + wa) + ' ' + y.waist +
      'C' + (cx + wa) + ' ' + (y.waist - 11) + ' ' + (cx + bu) + ' ' + (y.bust + 11) + ' ' + (cx + bu) + ' ' + y.bust +
      'C' + (cx + bu) + ' ' + (y.bust - 8) + ' ' + (cx + sh + 1) + ' ' + (y.shoulder + 8) + ' ' + (cx + sh) + ' ' + y.shoulder + 'Z';
    out += '<path class="on-sq-fig-line on-sq-fig-body" d="' + t + '"/>';
    // ben, avsmalnande mot fotknolen
    out += '<path class="on-sq-fig-line on-sq-fig-body" d="M' + (cx - hi) + ' ' + crotch +
      ' L' + (cx - gap) + ' ' + crotch + ' L' + (cx - gap - 1) + ' ' + hem +
      ' L' + (cx - gap - 1 - ankle * 2) + ' ' + hem + ' Z"/>';
    out += '<path class="on-sq-fig-line on-sq-fig-body" d="M' + (cx + hi) + ' ' + crotch +
      ' L' + (cx + gap) + ' ' + crotch + ' L' + (cx + gap + 1) + ' ' + hem +
      ' L' + (cx + gap + 1 + ankle * 2) + ' ' + hem + ' Z"/>';
    // matbandet langs innerbenet
    out += '<path class="on-sq-fig-mark" d="M' + (cx - 10) + ' ' + crotch + ' V' + hem + '"/>';
    out += '<path class="on-sq-fig-mark" d="M' + (cx - 14) + ' ' + crotch + ' H' + (cx - 6) +
      ' M' + (cx - 14) + ' ' + hem + ' H' + (cx - 6) + '"/>';
    return out + '</svg>';
  }

  function figure(group, key) {
    if (group === 'legs') return figureLegs(key);
    var set = FIG_SHAPES[group];
    var w = set[key];
    var cx = FIG_W / 2;
    var level = set.level;
    var y = FIG_Y[level];
    var half = w[level] / 2;
    var reach = half + 7;

    var out = '<svg viewBox="0 0 ' + FIG_W + ' ' + FIG_H + '" aria-hidden="true" focusable="false">';
    // huvud och hals, sa silhuetten last som en kropp och inte som en vas
    out += '<circle class="on-sq-fig-line" cx="' + cx + '" cy="14" r="9"/>';
    out += '<path class="on-sq-fig-line" d="M' + (cx - 5) + ' 23 L' + (cx - 5) + ' 30 M' + (cx + 5) + ' 23 L' + (cx + 5) + ' 30"/>';
    out += '<path class="on-sq-fig-line on-sq-fig-body" d="' + figPath(w) + '"/>';
    // matbandet: heldragen linje med andmarkeringar pa exakt den niva fragan galler
    out += '<path class="on-sq-fig-mark" d="M' + (cx - reach) + ' ' + y + ' H' + (cx + reach) + '"/>';
    out += '<path class="on-sq-fig-mark" d="M' + (cx - reach) + ' ' + (y - 4) + ' V' + (y + 4) +
           ' M' + (cx + reach) + ' ' + (y - 4) + ' V' + (y + 4) + '"/>';
    return out + '</svg>';
  }

  /* ------------------------------------------------------------------ *
   * Body estimation                                                     *
   *                                                                     *
   * Circumferences are estimated from height, weight, age and self-      *
   * reported shape. The coefficients below are a starting point, not     *
   * ground truth. Calibrate them against real return-reason data.        *
   * ------------------------------------------------------------------ */
  var AGE_MID = { '18-24': 21, '25-34': 30, '35-44': 40, '45-54': 50, '55-64': 60, '65+': 70 };

  var SHAPE = {
    waist: { flat: -4.5, average: 0, round: 5.5 },
    hips: { narrow: -3.5, average: 0, wide: 4.5 },
    bust: { small: -4.0, average: 0, full: 5.0 }
  };

  /* layer_base: tunt underställ under plagget (quizupplägget "lager", 2026-10-16).
     Mitt emellan normal och ledig: ett tunt lager tar en dryg centimeter. */
  var FIT_OFFSET = { tight: -1.5, regular: 0, layer_base: 1.0, loose: 2.5 };

  function estimateBody(a) {
    var h = a.height;
    var bmi = a.weight / Math.pow(h / 100, 2);
    var age = AGE_MID[a.age] || 40;
    var over30 = Math.max(0, age - 30);

    /* Midjan vaxer INTE linjart med BMI hela vagen. Den gamla raka linjen gav
       112 cm vid BMI 37,5 - flera cm over verkligheten - och slog darmed ut
       kraftiga kunder ur tabellen helt. Over BMI 27 planar kurvan ut. */
    var bmiWaist = bmi <= 27 ? 2.30 * bmi : 2.30 * 27 + 1.45 * (bmi - 27);

    var m = {
      waist: bmiWaist + 22.0 + over30 * 0.13 + (h - 168) * -0.18,
      hip: 2.05 * bmi + 51.0 - over30 * 0.04 + (h - 168) * -0.12,
      bust: 1.95 * bmi + 45.0 + (h - 168) * -0.10
    };

    m.waist += SHAPE.waist[a.waist] || 0;
    m.hip += SHAPE.hips[a.hips] || 0;
    m.bust += SHAPE.bust[a.bust] || 0;

    m.bmi = bmi;
    return m;
  }

  function scoreSizes(sizes, m, fitOffset, dims) {
    var scored = [];
    for (var i = 0; i < sizes.length; i++) {
      var s = sizes[i];
      var penalty = 0;
      var usedWeight = 0;
      for (var d = 0; d < dims.length; d++) {
        var key = dims[d].key;
        var range = s[key];
        if (!range || m[key] == null) continue;
        var v = m[key] + fitOffset;
        var lo = range[0], hi = range[1];
        var half = Math.max((hi - lo) / 2, 1);
        /* Osymmetriskt med flit. Nastan alla plagg har resar eller stretch i
           midjan, sa att ligga OVER spannet kostar lite - tyget ger efter. Att
           ligga UNDER betyder daremot ett plagg som hanger, och det gar inte att
           tanja bort. Returerna i butiken handlar om benlangd, inte om midja och
           hoft, sa girth ska inte kasta upp kunden flera storlekar i onodan. */
        var p;
        if (v < lo) p = 1 + (lo - v) / 2.5;
        else if (v > hi) p = 0.4 + (v - hi) / 4;
        else p = (Math.abs(v - (lo + hi) / 2) / half) * 0.6;
        penalty += p * dims[d].weight;
        usedWeight += dims[d].weight;
      }
      if (usedWeight === 0) continue;
      scored.push({ index: i, size: s, penalty: penalty / usedWeight });
    }
    scored.sort(function (a, b) { return a.penalty - b.penalty; });
    return scored;
  }

  /* BENLANGDEN ar ett GOLV, inte ett tiebreak.
     Butikens returer kommer fran att byxorna ar for korta, inte fran midja och
     hoft (nastan allt ar elastiskt i linningen). Darfor far langden bestamma den
     MINSTA storlek kunden kan fa: hittar vi ingen tillrackligt lang byxa i den
     storlek girth pekar ut, hojs storleken tills innerbenet racker. Nedgradering
     for korta ben sker aldrig - en for lang byxa gar att vika upp, en for kort
     gar inte att forlanga.
     Faktorn ar kalibrerad mot butikens egen tabell: 175 cm bar 2XL pa QuickDry
     (71 cm innerben), alltsa 71/175 = 0,406. Att tabellens langdkolumn ar graderad
     for kortare personer an vad midjekolumnen antyder ar just det kunderna klagar
     pa - modellen ska folja tabellen, inte tvartom. */
  /* Innerben per centimeter kroppslangd. KALIBRERAD, inte gissad: 0,406 gav
     71,1 cm for en 175 cm lang kund, och da racker XS (70 cm) i Warm Fleece
     Pants tabell - vilket ar uppenbart fel. Victor: vid 175 cm ar det XL
     eller 2XL som galler for langden. 0,428 x 175 = 74,9, minus toleransen
     nedan = 73,4, och forsta innerben som racker blir da XL:s 74. */
  var LEG_RATIO = 0.428;
  /* Halva steget mellan tva storlekar (~1,5 cm) accepteras som for kort. Lagre varde
     ger tvasteg-hopp vid tabellgranser, hogre varde gor byxan for kort. */
  var LEG_TOL = 1.5;

  /* Benfragan justerar behovet i cm. OSYMMETRISKT med flit: "langre ben" lyfter mer
     an "kortare ben" sanker, for att en byxa som blir en aning for lang gar att vika
     upp medan en for kort blir en retur. Svaret ar en sjalvskattning och far darfor
     inte kunna gora storre skada an sa. */
  var LEG_BIAS = { short: -2.0, average: 0, long: 3.0 };

  /* Minsta storleksindex vars innerben racker till kundens langd.
     -1 = tabellen saknar langdmatt (toppar, skor) och langden spelar ingen roll. */
  function legFloorIndex(sizes, height, bias, legNeed) {
    if (!height && !legNeed) return -1;
    /* legNeed: kundens eget innerben (quizupplägget innerben) i stället för
       det som räknas fram ur längden. Allt annat i golvet är detsamma. */
    var need = legNeed || (height * LEG_RATIO + (bias || 0));
    var longest = -1;
    for (var i = 0; i < sizes.length; i++) {
      var ins = sizes[i].inseam;
      if (typeof ins !== 'number' || ins <= 0) continue;
      longest = i;
      if (ins >= need - LEG_TOL) return i;
    }
    /* Langre ben an hela tabellen: ge den langsta som finns i stallet for ingenting. */
    return longest;
  }

  function recommend(sizeSet, answers) {
    var m = estimateBody(answers);
    var dims = sizeSet.dimensions || [{ key: 'waist', weight: 0.55 }, { key: 'hip', weight: 0.45 }];
    /* Uppmätta omkretsar (quizupplägget midja och höft i cm) ersätter
       skattningen, och då räknas bara de mått kunden faktiskt angett. Resten av
       kedjan, poängen och benlängdens golv, är densamma. */
    if (answers.measured) {
      var mf = [];
      for (var mk in answers.measured) {
        if (typeof answers.measured[mk] === 'number' && answers.measured[mk] > 0) m[mk] = answers.measured[mk];
      }
      for (var di = 0; di < dims.length; di++) {
        if (typeof answers.measured[dims[di].key] === 'number') mf.push(dims[di]);
      }
      if (mf.length) dims = mf;
    }
    var scored = scoreSizes(sizeSet.sizes, m, FIT_OFFSET[answers.fit] || 0, dims);
    if (!scored.length) return null;

    var best = scored[0];
    var runnerUp = scored[1] || null;
    var between = runnerUp ? (runnerUp.penalty - best.penalty) < 0.45 : false;

    /* Golvet appliceras sist, sa girth-poangen alltid ar rakt raknad. Hojs storleken
       av langden ar valet inte langre "mellan tva" - det ar ett medvetet val. */
    var legRaised = false;
    var floorIdx = legFloorIndex(sizeSet.sizes, answers.height, LEG_BIAS[answers.legs] || 0, answers.legNeed);
    /* MAX TVA STEG. Arbetsordern sager att benlangden kompenserar uppat hogst
       tva storlekar; koden hade ingen gräns, och darfor fick en lang och smal
       kund den STORSTA storleken i tabellen bara for att ingen innerbenslangd
       rackte till. Matt pa Warm Fleece Pants: 190 cm och 60-74 kg gav 4XL.
       Omkretsen avgor storleken, langden far justera den - inte tvartom. */
    /* Hur manga steg langden far lyfta. Arbetsordern sager tva; hans
       "XL vid 175" kraver tre nar kunden ar smal. Darfor en installning i
       stallet for en siffra i koden, med tva som standard. */
    var maxSteg = (sizeSet && typeof sizeSet.legMaxSteps === 'number') ? sizeSet.legMaxSteps : 2;
    if (maxSteg >= 0 && floorIdx > best.index + maxSteg) floorIdx = best.index + maxSteg;
    if (floorIdx > -1 && best.index < floorIdx) {
      for (var f = 0; f < scored.length; f++) {
        if (scored[f].index === floorIdx) {
          best = scored[f];
          between = false;
          runnerUp = null;
          legRaised = true;
          break;
        }
      }
    }

    return {
      size: best.size.label,
      penalty: best.penalty,
      /* Hela raden folj med, sa benlangdskontrollen kommer at plaggets innerben. */
      sizeRow: best.size,
      /* Langden valde storleken - da ar girth-poangen ointressant. */
      outOfRange: legRaised ? false : best.penalty > 2.6,
      legRaised: legRaised,
      between: between,
      alternative: between ? runnerUp.size.label : null,
      alternativeIsLarger: between ? runnerUp.index > best.index : false,
      measurements: { waist: Math.round(m.waist), hip: Math.round(m.hip), bust: Math.round(m.bust) }
    };
  }

  /* ------------------------------------------------------------------ *
   * Storage                                                             *
   * ------------------------------------------------------------------ */
  function loadProfile() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return null; }
  }
  function saveProfile(answers) {
    try { window.localStorage.setItem(STORAGE_KEY, JSON.stringify(answers)); } catch (e) {}
  }
  function clearProfile() {
    try { window.localStorage.removeItem(STORAGE_KEY); } catch (e) {}
  }

  /* ------------------------------------------------------------------ *
   * Helpers                                                             *
   * ------------------------------------------------------------------ */
  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }
  function fmt(str, vars) {
    return String(str).replace(/\{(\w+)\}/g, function (_, k) { return vars[k] != null ? vars[k] : ''; });
  }
  /* "2XL", "XXL" och " 2xl " ar samma storlek. Utan normalisering hittade vi
     ingen variant och knappen pastod att storleken var slut. */
  function normSize(v) {
    var s = String(v == null ? '' : v).trim().toUpperCase().replace(/\s+/g, '');
    var m = s.match(/^(X{2,})(S|L)$/);
    if (m) return m[1].length + 'X' + m[2];
    return s;
  }
  function escapeHtml(v) {
    return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function cmToFtIn(cm) {
    var inches = Math.round(cm / 2.54);
    return Math.floor(inches / 12) + "'" + (inches % 12) + '"';
  }
  function kgToLb(kg) { return Math.round(kg * 2.20462); }

  var ICON_PENCIL = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 3a2.8 2.8 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z"/></svg>';
  var ICON_ARROW = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
  var ICON_CHECK = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';
  var ICON_RULER = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="8" width="20" height="8" rx="1.5"/><path d="M6 8v3M10 8v5M14 8v3M18 8v5"/></svg>';
  var ICON_CROSS = '<svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.4" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg>';

  /* ------------------------------------------------------------------ *
   * Quiz instance                                                       *
   * ------------------------------------------------------------------ */
  function Quiz(config) {
    this.cfg = config;
    /* Omgång 56: Shopifys t-filter HTML-kodar texterna ("What&#39;s"), och här skrivs de som
       text, inte HTML. Avkoda de vanliga tecknen en gång. */
    if (config.two) {
      Object.keys(config.two).forEach(function (k) {
        var v = config.two[k];
        if (typeof v === 'string' && v.indexOf('&') > -1) config.two[k] = v.replace(/&#39;/g, "'").replace(/&quot;/g, '"').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&');
      });
    }
    this.t = Object.assign({}, SV, config.strings || {});
    this.sizeSet = config.sizeSet;
    this.stepIds = (this.sizeSet.steps || ['height', 'weight', 'age', 'waist', 'hips', 'fit']).slice();
    this.units = { length: config.defaultUnits && config.defaultUnits.length || 'cm',
                   weight: config.defaultUnits && config.defaultUnits.weight || 'kg' };

    /* Tvafragorslaget. Ett LAGE i samma motor, inte en kopia. Sattningen
       kommer fran config och bara de nya designerna skickar den, sa
       sexstegsflodet ar oforandrat. */
    this.two = config.mode === 'two';
    /* Vald fragesuppsattning. Kraver den kroppsmatt som produkten saknar
       faller vi tillbaka pa storlek + passform, sa quizet aldrig star och
       fragar efter nagot det inte kan rakna pa. */
    this.quizSet = QUIZ_SETS[config.quizSet] ? config.quizSet : 'size_fit';
    /* Upplägg som kräver ett visst mått i tabellen (midja/höft, innerben)
       faller tillbaka på längd, vikt och kroppsform när produkten saknar det. */
    /* Omgång 85 (Victor): Visa måttfält av = inga fält för midja, höft eller innerben i cm.
       Uppläggen som bygger på sådana fält blir då längd, vikt och kroppsform. */
    this.measureFields = config.measureFields === true;
    if (QUIZ_SETS[this.quizSet].needs && (!this.measureFields || !setUsable(this.sizeSet, QUIZ_SETS[this.quizSet].needs))) this.quizSet = 'body_shape';
    if (QUIZ_SETS[this.quizSet].body && !bodyUsable(this.sizeSet)) this.quizSet = 'size_fit';
    this.twoSteps = QUIZ_SETS[this.quizSet].steps;
    /* Omgång 56: kroppsformen bara för byxor, tights och shorts (tabellen har höft eller
       midja men ingen byst), längden bara när tabellen har innerben. */
    if (this.quizSet === 'smart') {
      var ss = this.sizeSet, kort = !!config.cropped;
      this.twoSteps = this.twoSteps.filter(function (s) {
        if (s === 'form') return smartHasForm(ss);
        /* Capri och shorts är korta med flit: längden säger inget om storleken. */
        if (s === 'height') return !kort && smartHasInseam(ss);
        return true;
      });
    }
    this.twoCursor = 0;
    this.twoAnswers = {};
    /* Omgång 58: quizbannern ("2 frågor. 15 sekunder.") räknar frågorna som produkten
       faktiskt får i det valda quizet. */
    var antalQ = this.two ? this.twoSteps.length : this.stepIds.length;
    var sek = antalQ <= 1 ? 10 : antalQ === 2 ? 15 : antalQ === 3 ? 20 : antalQ === 4 ? 30 : antalQ * 8;
    Array.prototype.forEach.call(document.querySelectorAll('.on-sqbn__head[data-qb]'), function (h) {
      var mode = h.getAttribute('data-qb');
      var tp = mode === 'auto' ? h.getAttribute(antalQ > 2 ? 'data-qb-a4' : 'data-qb-a2') : h.getAttribute('data-qb-t');
      var tx = String(tp || '').split('{n} ').join(antalQ + '\u00a0').split('{s} ').join(sek + '\u00a0').split('{n}').join(antalQ).split('{s}').join(sek);
      if (tx && h.textContent !== tx) h.textContent = tx;
    });

    var saved = loadProfile();
    this.answers = saved || {};
    this.cursor = saved ? this.stepIds.length : 0; // returning shoppers land straight on the result
    this.draft = {};
    this.build();
    this.syncTrigger();
  }

  Quiz.prototype.build = function () {
    var self = this;

    this.overlay = el('div', 'on-sq on-sq-overlay' + (this.two ? ' on-sq--two' : ''));
    this.overlay.setAttribute('data-open', 'false');
    this.overlay.addEventListener('click', function () { self.close(); });

    this.panel = el('div', 'on-sq on-sq-panel' + (this.two ? ' on-sq--two' : ''));
    this.panel.setAttribute('data-open', 'false');
    this.panel.setAttribute('role', 'dialog');
    this.panel.setAttribute('aria-modal', 'true');
    this.panel.setAttribute('aria-label', this.t.trigger);

    var head = el('div', 'on-sq-head');
    if (this.cfg.logo) {
      var logo = el('span', 'on-sq-brand on-sq-brand--logo');
      var img = document.createElement('img');
      img.src = this.cfg.logo;
      img.alt = this.cfg.brandLabel || '';
      img.loading = 'lazy';
      logo.appendChild(img);
      head.appendChild(logo);
    } else {
      head.appendChild(el('span', 'on-sq-brand', this.cfg.brandLabel || this.t.brand));
    }
    var close = el('button', 'on-sq-close', ICON_CROSS);
    close.type = 'button';
    close.setAttribute('aria-label', this.t.close);
    close.addEventListener('click', function () { self.close(); });
    head.appendChild(close);

    this.body = el('div', 'on-sq-body');

    this.foot = el('div', 'on-sq-foot');
    var privacy = el('span', null, this.cfg.privacyUrl
      ? '<a href="' + this.cfg.privacyUrl + '">' + this.t.privacy + '</a>'
      : '');
    this.progress = el('span', 'on-sq-progress');
    this.topBtn = el('button', 'on-sq-top', this.t.back_to_top);
    this.topBtn.type = 'button';
    this.topBtn.addEventListener('click', function () { self.body.scrollTo({ top: 0 }); });
    this.foot.appendChild(privacy);
    this.foot.appendChild(this.progress);
    this.foot.appendChild(this.topBtn);

    this.panel.appendChild(head);
    this.panel.appendChild(this.body);
    this.panel.appendChild(this.foot);

    document.body.appendChild(this.overlay);
    document.body.appendChild(this.panel);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && self.panel.getAttribute('data-open') === 'true') self.close();
      if (self.two) self.twoTrapFocus(e);
    });
  };

  Quiz.prototype.open = function () {
    this.lastFocus = document.activeElement;
    /* Oppnar kunden quizet igen utan att ha svarat borjar det om fran
       forsta fragan. Har hen svarat visas resultatet direkt - att tvinga om
       samma tva fragor vore att be om samma svar en gang till. */
    if (this.two) {
      /* Oppnas quizet igen efter ett svar ska det inte hoppa till resultatet
         om fragorna ar fler an de besvarade. */
      var klara = 0;
      for (var qi = 0; qi < this.twoSteps.length; qi++) {
        var sk = this.twoSteps[qi];
        /* Höftmåttet besvarar kroppsformen, och passformen hoppas då över (omgång 56). */
        var svar = this.twoAnswers[sk] != null || (sk === 'form' && (this.twoAnswers.hip_cm || this.twoAnswers.waist_cm)) || (this.twoSkip && this.twoSkip(qi));
        if (!svar) break;
        klara++;
      }
      this.twoCursor = klara;
    }
    this.overlay.setAttribute('data-open', 'true');
    this.panel.setAttribute('data-open', 'true');
    document.documentElement.style.overflow = 'hidden';
    this.render();
    var first = this.panel.querySelector('.on-sq-close');
    if (first) first.focus();
  };

  Quiz.prototype.close = function () {
    this.overlay.setAttribute('data-open', 'false');
    this.panel.setAttribute('data-open', 'false');
    document.documentElement.style.overflow = '';
    if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
  };

  /* ---------- rendering ---------- */

  Quiz.prototype.render = function () {
    if (this.two) return this.renderTwo();
    var self = this;
    this.body.innerHTML = '';

    if (this.cursor === 0) this.body.appendChild(this.renderIntro());

    if (this.cursor > 0) {
      var rows = el('div', 'on-sq-rows');
      for (var i = 0; i < this.cursor && i < this.stepIds.length; i++) {
        rows.appendChild(this.renderRow(this.stepIds[i], i));
      }
      this.body.appendChild(rows);
    }

    if (this.cursor < this.stepIds.length) {
      this.body.appendChild(this.renderStep(this.stepIds[this.cursor]));
      this.progress.textContent = (this.cursor + 1) + ' / ' + (this.stepIds.length + 1);
    } else {
      this.body.appendChild(this.renderResult());
      this.progress.textContent = (this.stepIds.length + 1) + ' / ' + (this.stepIds.length + 1);
    }

    this.topBtn.style.visibility = this.cursor > 1 ? 'visible' : 'hidden';
    window.requestAnimationFrame(function () {
      var step = self.body.querySelector('.on-sq-step, .on-sq-result');
      if (step && self.cursor > 0) step.scrollIntoView({ block: 'start' });
    });
  };

  Quiz.prototype.renderIntro = function () {
    var wrap = document.createDocumentFragment();
    var intro = el('div', 'on-sq-intro');
    intro.appendChild(el('div', 'on-sq-intro-text',
      '<h2>' + this.t.intro_title + '</h2><p>' + this.t.intro_body + '</p>'));
    var img = el('div', 'on-sq-intro-img');
    if (this.cfg.introImage) img.style.backgroundImage = 'url("' + this.cfg.introImage + '")';
    intro.appendChild(img);
    wrap.appendChild(intro);

    var strip = el('div', 'on-sq-strip');
    if (this.cfg.product && this.cfg.product.image) {
      var pi = new Image();
      pi.src = this.cfg.product.image;
      pi.alt = '';
      strip.appendChild(pi);
    } else {
      strip.appendChild(el('span', 'on-sq-strip-fallback'));
    }
    strip.appendChild(el('span', null, this.t.strip));
    wrap.appendChild(strip);

    // Returtexten hor hemma har, innan kunden svarar - inte efter att storleken
    // redan ar satt. Da ar den ett skal att gora quizet, inte en efterhandsnot.
    var note = this.cfg.note || this.t.note;
    if (note) wrap.appendChild(el('p', 'on-sq-note', escapeHtml(note)));

    return wrap;
  };

  Quiz.prototype.renderRow = function (id, index) {
    var self = this;
    var row = el('button', 'on-sq-row');
    row.type = 'button';
    row.appendChild(el('span', 'on-sq-row-label', this.t[id]));
    row.appendChild(el('span', 'on-sq-row-value', this.summaryValue(id) + ICON_PENCIL));
    row.addEventListener('click', function () {
      self.cursor = index;
      self.draft = {};
      self.render();
    });
    return row;
  };

  Quiz.prototype.summaryValue = function (id) {
    var a = this.answers, t = this.t;
    switch (id) {
      case 'height':
        return fmt(t.height_value, { value: this.units.length === 'cm'
          ? a.height + ' ' + t.cm : cmToFtIn(a.height) });
      case 'weight':
        return fmt(t.weight_value, { value: this.units.weight === 'kg'
          ? a.weight + ' ' + t.kg : kgToLb(a.weight) + ' ' + t.lb });
      case 'age': return fmt(t.age_value, { value: a.age });
      case 'waist': return t['waist_' + a.waist];
      case 'hips': return t['hips_' + a.hips];
      case 'legs': return t['legs_' + a.legs];
      case 'bust': return t['bust_' + a.bust];
      case 'fit': return t['fit_' + (a.fit === 'tight' ? 'tight' : a.fit === 'loose' ? 'loose' : 'regular')];
      default: return '';
    }
  };

  Quiz.prototype.renderStep = function (id) {
    var map = {
      height: this.stepHeight, weight: this.stepWeight, age: this.stepAge,
      waist: this.stepShape('waist', ['flat', 'average', 'round']),
      hips: this.stepShape('hips', ['narrow', 'average', 'wide']),
      legs: this.stepShape('legs', ['short', 'average', 'long']),
      bust: this.stepShape('bust', ['small', 'average', 'full']),
      fit: this.stepFit
    };
    return map[id].call(this);
  };

  Quiz.prototype.nextButton = function (enabled, onNext, isLast) {
    var self = this;
    var last = isLast != null ? isLast : (this.cursor === this.stepIds.length - 1);
    var btn = el('button', 'on-sq-next',
      '<span>' + (last ? this.t.done : this.t.next) + '</span>' + (last ? ICON_CHECK : ICON_ARROW));
    btn.type = 'button';
    btn.disabled = !enabled;
    btn.addEventListener('click', function () {
      onNext();
      saveProfile(self.answers);
      self.cursor = Math.min(self.cursor + 1, self.stepIds.length);
      // when editing an earlier answer, jump straight back to the result
      if (self.everCompleted) self.cursor = self.stepIds.length;
      self.draft = {};
      self.render();
      self.syncTrigger();
    });
    return btn;
  };

  Quiz.prototype.stepHeight = function () {
    var self = this;
    var wrap = el('div', 'on-sq-step');
    var head = el('div', 'on-sq-qhead');
    head.appendChild(el('h3', null, this.t.height_q));

    var units = el('div', 'on-sq-units');
    ['cm', 'ft'].forEach(function (u) {
      var b = el('button', null, self.t[u]);
      b.type = 'button';
      b.setAttribute('aria-pressed', String(self.units.length === u));
      b.addEventListener('click', function () { self.units.length = u; self.render(); });
      units.appendChild(b);
    });
    head.appendChild(units);
    wrap.appendChild(head);

    var value = this.answers.height || 168;
    var readout = el('div', 'on-sq-readout');
    var prev = el('span', 'on-sq-ghost');
    var now = el('span', 'on-sq-now');
    var next = el('span', 'on-sq-ghost');
    readout.appendChild(prev); readout.appendChild(now); readout.appendChild(next);
    wrap.appendChild(readout);

    var ruler = el('div', 'on-sq-ruler');
    ruler.appendChild(el('div', 'on-sq-ticks'));
    var range = el('input');
    range.type = 'range';
    range.className = 'on-sq-range';
    range.min = 140; range.max = 200; range.step = 1; range.value = value;
    range.setAttribute('aria-label', this.t.height_q);
    ruler.appendChild(range);
    wrap.appendChild(ruler);

    function paint() {
      var v = parseInt(range.value, 10);
      var show = function (n) { return self.units.length === 'cm' ? n + ' ' + self.t.cm : cmToFtIn(n); };
      prev.textContent = v > 140 ? show(v - 5) : '';
      now.textContent = show(v);
      next.textContent = v < 200 ? show(v + 5) : '';
      range.setAttribute('aria-valuetext', show(v));
    }
    range.addEventListener('input', paint);
    paint();

    wrap.appendChild(this.nextButton(true, function () {
      self.answers.height = parseInt(range.value, 10);
    }));
    return wrap;
  };

  Quiz.prototype.stepWeight = function () {
    var self = this;
    var wrap = el('div', 'on-sq-step');
    var head = el('div', 'on-sq-qhead');
    head.appendChild(el('h3', null, this.t.weight_q));

    var units = el('div', 'on-sq-units');
    ['kg', 'lb'].forEach(function (u) {
      var b = el('button', null, self.t[u]);
      b.type = 'button';
      b.setAttribute('aria-pressed', String(self.units.weight === u));
      b.addEventListener('click', function () { self.units.weight = u; self.render(); });
      units.appendChild(b);
    });
    head.appendChild(units);
    wrap.appendChild(head);

    var readout = el('div', 'on-sq-readout');
    var prev = el('span', 'on-sq-ghost');
    var now = el('span', 'on-sq-now');
    var next = el('span', 'on-sq-ghost');
    readout.appendChild(prev); readout.appendChild(now); readout.appendChild(next);
    wrap.appendChild(readout);

    var ruler = el('div', 'on-sq-ruler');
    ruler.appendChild(el('div', 'on-sq-ticks'));
    var range = el('input');
    range.type = 'range';
    range.className = 'on-sq-range';
    range.min = 40; range.max = 140; range.step = 1;
    range.value = this.answers.weight || 70;
    range.setAttribute('aria-label', this.t.weight_q);
    ruler.appendChild(range);
    wrap.appendChild(ruler);

    function paint() {
      var v = parseInt(range.value, 10);
      var show = function (n) { return self.units.weight === 'kg' ? n + ' ' + self.t.kg : kgToLb(n) + ' ' + self.t.lb; };
      prev.textContent = v > 40 ? show(v - 5) : '';
      now.textContent = show(v);
      next.textContent = v < 140 ? show(v + 5) : '';
      range.setAttribute('aria-valuetext', show(v));
    }
    range.addEventListener('input', paint);
    paint();

    wrap.appendChild(this.nextButton(true, function () {
      self.answers.weight = parseInt(range.value, 10);
    }));
    return wrap;
  };

  Quiz.prototype.stepAge = function () {
    var self = this;
    var wrap = el('div', 'on-sq-step');
    wrap.appendChild(el('h3', null, this.t.age_q));
    wrap.appendChild(el('p', 'on-sq-help', this.t.age_help));

    var picked = this.draft.age || this.answers.age || null;
    var pills = el('div', 'on-sq-pills');
    var next;
    Object.keys(AGE_MID).forEach(function (band) {
      var b = el('button', 'on-sq-pill', band);
      b.type = 'button';
      b.setAttribute('aria-pressed', String(picked === band));
      b.addEventListener('click', function () {
        picked = band;
        Array.prototype.forEach.call(pills.children, function (c) {
          c.setAttribute('aria-pressed', String(c === b));
        });
        next.disabled = false;
      });
      pills.appendChild(b);
    });
    wrap.appendChild(pills);

    next = this.nextButton(!!picked, function () { self.answers.age = picked; });
    wrap.appendChild(next);
    return wrap;
  };

  Quiz.prototype.stepShape = function (group, keys) {
    return function () {
      var self = this;
      var wrap = el('div', 'on-sq-step');
      wrap.appendChild(el('h3', null, this.t[group + '_q']));

      var picked = this.answers[group] || 'average';
      var choices = el('div', 'on-sq-choices');
      keys.forEach(function (key) {
        var b = el('button', 'on-sq-choice',
          figure(group, key) + '<span>' + self.t[group + '_' + key] + '</span>');
        b.type = 'button';
        b.setAttribute('aria-pressed', String(picked === key));
        b.addEventListener('click', function () {
          picked = key;
          Array.prototype.forEach.call(choices.children, function (c) {
            c.setAttribute('aria-pressed', String(c === b));
          });
        });
        choices.appendChild(b);
      });
      wrap.appendChild(choices);

      wrap.appendChild(this.nextButton(true, function () { self.answers[group] = picked; }));
      return wrap;
    };
  };

  Quiz.prototype.stepFit = function () {
    var self = this;
    var order = ['tight', 'regular', 'loose'];
    var wrap = el('div', 'on-sq-step');
    wrap.appendChild(el('h3', null, this.t.fit_q));

    var current = order.indexOf(this.answers.fit || 'regular');
    if (current < 0) current = 1;

    var box = el('div', 'on-sq-fit');
    var range = el('input');
    range.type = 'range';
    range.className = 'on-sq-fitrange';
    range.min = 0; range.max = 2; range.step = 1; range.value = current;
    range.setAttribute('aria-label', this.t.fit_q);
    box.appendChild(range);

    var labels = el('div', 'on-sq-fit-labels');
    var spans = order.map(function (key) {
      var s = el('span', null, self.t['fit_' + key]);
      labels.appendChild(s);
      return s;
    });
    box.appendChild(labels);
    wrap.appendChild(box);

    function paint() {
      var i = parseInt(range.value, 10);
      spans.forEach(function (s, n) { s.setAttribute('data-active', String(n === i)); });
      range.setAttribute('aria-valuetext', self.t['fit_' + order[i]]);
    }
    range.addEventListener('input', paint);
    paint();

    wrap.appendChild(this.nextButton(true, function () {
      self.answers.fit = order[parseInt(range.value, 10)];
    }, true));
    return wrap;
  };

  /* ---------- result ---------- */

  Quiz.prototype.renderResult = function () {
    var self = this;
    this.everCompleted = true;

    var rec = recommend(this.sizeSet, this.answers);
    this.result = rec;

    var wrap = el('div', 'on-sq-result');
    wrap.appendChild(el('h3', null, this.t.result_title));
    wrap.appendChild(el('p', null, this.t.result_sub));

    /* Ingen varningstext langre, aven nar kunden ligger utanfor tabellen. Vi
       visar narmaste storlek rakt av. En text som sager att plagget kanske inte
       racker till far kunden att avbryta kopet, och storleksspannet ar redan
       synligt i storleksguiden for den som vill kontrollera. */
    if (!rec) {
      var guideA = el('button', 'on-sq-link', this.t.size_guide);
      guideA.type = 'button';
      guideA.addEventListener('click', function () { self.openSizeGuide(); });
      wrap.appendChild(guideA);
      return wrap;
    }

    /* Rubriken far hela kortets bredd pa egen rad, bild och storlek under.
       Bredvid bilden rackte utrymmet inte till pa svenska ("...rekommenderar
       vi" brots till tva rader) - har far alla 12 sprak plats pa en rad. */
    var card = el('div', 'on-sq-card');
    card.appendChild(el('p', 'on-sq-card-label', this.t.result_for));
    if (this.cfg.product && this.cfg.product.image) {
      var img = new Image();
      img.src = this.cfg.product.image;
      img.alt = this.cfg.product.title || '';
      img.className = 'on-sq-card-img';
      card.appendChild(img);
    } else {
      card.appendChild(el('div', 'on-sq-card-img'));
    }
    card.appendChild(el('strong', 'on-sq-card-size', escapeHtml(this.sizeLabel(rec.size))));
    wrap.appendChild(card);

    /* Ingen "mellan tva storlekar"-text och ingen benlangdsvarning langre.
       Tvivel saljer inte, och passformen ar redan besvarad i sista fragan.
       Benlangden ligger i stallet i uttrakningen (se recommend). */

    var prod = this.cfg.product || {};
    var sizeIdx = typeof prod.sizeIndex === 'number' ? prod.sizeIndex : 0;
    var names = prod.optionNames || [];
    // Varianter i den rekommenderade storleken. Normaliserat, sa "2XL" i
    // tabellen matchar "XXL" bland varianterna.
    var variants = (prod.variants || []).filter(function (v) {
      return normSize(v.size) === normSize(rec.size);
    });

    var label = this.sizeLabel(rec.size);
    var toCart = this.cfg.resultAction === 'cart';

    if (toCart && variants.length) {
      // Kunden ska kunna valja ALLA optioner har, inte bara farg - annars
      // hamnar fel benstil i varukorgen.
      var otherIdx = [];
      for (var i = 0; i < names.length; i++) if (i !== sizeIdx) otherIdx.push(i);

      var picked = {};
      var firstOk = variants.filter(function (v) { return v.available; })[0] || variants[0];
      otherIdx.forEach(function (i) { picked[i] = firstOk.options[i]; });

      var current = function () {
        return variants.filter(function (v) {
          return otherIdx.every(function (i) { return v.options[i] === picked[i]; });
        })[0] || null;
      };

      var atc = el('button', 'on-sq-atc');
      atc.type = 'button';

      var refresh = function () {
        var v = current();
        atc.disabled = !v || !v.available;
        atc.textContent = v && v.available
          ? fmt(self.t.add, { size: label })
          : fmt(self.t.sold_out, { size: label });
      };

      // Bild-swatchar med samma kallor som variantvaljaren, i stallet for
      // dropdowns. Kunden ska kanna igen sig fran produktsidan.
      var meta = {};
      (prod.optionValues || []).forEach(function (o) { meta[o.index] = o.values || []; });
      var chips = {};

      otherIdx.forEach(function (i) {
        var values = [];
        variants.forEach(function (v) {
          if (values.indexOf(v.options[i]) === -1) values.push(v.options[i]);
        });
        if (values.length < 2) return;

        var box = el('div', 'on-sq-opt');
        var head = el('div', 'on-sq-opt-head');
        head.appendChild(el('span', 'on-sq-opt-name', escapeHtml(names[i] || self.t.color)));
        var valueOut = el('span', 'on-sq-opt-value', escapeHtml(picked[i]));
        head.appendChild(valueOut);
        box.appendChild(head);

        var row = el('div', 'on-sq-opt-row');
        chips[i] = [];
        values.forEach(function (val) {
          var info = meta[i].filter(function (m) { return m.name === val; })[0] || {};
          var inStock = variants.some(function (v) { return v.options[i] === val && v.available; });
          var b = el('button', 'on-sq-chip');
          b.type = 'button';
          b.title = val;
          b.setAttribute('aria-label', val);
          if (info.image) {
            b.classList.add('on-sq-chip--img');
            var im = new Image();
            im.src = info.image;
            im.alt = val;
            im.loading = 'lazy';
            b.appendChild(im);
          } else if (info.hex) {
            b.classList.add('on-sq-chip--dot');
            b.appendChild(el('span', 'on-sq-chip-dot')).style.background = info.hex;
          } else {
            b.classList.add('on-sq-chip--text');
            b.appendChild(el('span', null, escapeHtml(val)));
          }
          if (!inStock) b.classList.add('is-unavailable');
          b.setAttribute('aria-pressed', String(val === picked[i]));
          b.addEventListener('click', function () {
            picked[i] = val;
            valueOut.textContent = val;
            chips[i].forEach(function (c) { c.setAttribute('aria-pressed', String(c === b)); });
            refresh();
          });
          chips[i].push(b);
          row.appendChild(b);
        });
        box.appendChild(row);
        wrap.appendChild(box);
      });

      refresh();
      atc.addEventListener('click', function () {
        var v = current();
        if (v) self.addToCart(v.id, atc, wrap);
      });
      wrap.appendChild(atc);
    } else {
      /* Standard: skicka tillbaka kunden till produktsidan med storleken vald.
         Da valjer hen farg och benstil i den vanliga variantvaljaren, dar
         bilder och lagerstatus finns, och gar vidare darifran. */
      var pick = el('button', 'on-sq-atc', fmt(this.t.pick_size || 'Välj {size}', { size: label }));
      pick.type = 'button';
      pick.addEventListener('click', function () {
        self.close();
        setTimeout(function () {
          var form = document.querySelector('product-form-component, form[action*="/cart/add"]');
          var target = form || document.querySelector('.on-vp-wrap, variant-picker');
          if (target && target.scrollIntoView) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 80);
      });
      wrap.appendChild(pick);
    }

    if (this.hasSizeGuide()) {
      var guide = el('button', 'on-sq-link', this.t.size_guide);
      guide.type = 'button';
      guide.addEventListener('click', function () { self.openSizeGuide(); });
      wrap.appendChild(guide);
    }

    var reset = el('button', 'on-sq-link', this.t.restart);
    reset.type = 'button';
    if (this.hasSizeGuide()) reset.style.marginLeft = '16px';
    reset.addEventListener('click', function () {
      clearProfile();
      self.answers = {};
      self.cursor = 0;
      self.everCompleted = false;
      self.render();
      self.syncTrigger();
    });
    wrap.appendChild(reset);

    // let the product page preselect the variant
    document.dispatchEvent(new CustomEvent('on:size-quiz:result', {
      detail: {
        size: rec.size,
        alternative: rec.alternative,
        measurements: rec.measurements,
        variantId: (variants.filter(function (v) { return v.available; })[0] || variants[0] || {}).id || null,
        productId: this.cfg.product && this.cfg.product.id
      }
    }));

    return wrap;
  };

  /* Lade forut bara till raden och stangde panelen. Butikens /cart/add.js tar
     over tva sekunder, och utan besked hann kunden tro att knappen var trasig -
     dessutom fick temat aldrig veta nagot, sa varukorgssiffran i headern stod
     kvar. Nu: direkt "lagger till"-lage, sedan samma cart:update-handelse och
     sections-nyckel som resten av temat anvander, och drawern oppnas. */
  Quiz.prototype.addToCart = function (variantId, button, wrap) {
    var self = this;
    if (!variantId) return;
    var original = button.textContent;
    button.disabled = true;
    button.classList.add('is-busy');
    button.textContent = self.t.adding || original;

    var body = { items: [{ id: Number(variantId), quantity: 1 }] };
    var cic = document.querySelector('cart-items-component');
    var sid = cic ? (cic.getAttribute('section-id') || cic.getAttribute('data-section-id')) : null;
    if (sid) { body.sections = sid; body.sections_url = window.location.pathname; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('cart');
      return r.json();
    }).then(function (added) {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          button.classList.remove('is-busy');
          button.textContent = self.t.added;
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: 'on-size-quiz',
              data: { source: 'on-size-quiz', itemCount: cart.item_count, sections: added ? added.sections : null }
            }
          }));
          document.dispatchEvent(new CustomEvent('on:size-quiz:added', { detail: { variantId: variantId } }));
          window.setTimeout(function () {
            self.close();
            var drawer = document.querySelector('cart-drawer-component');
            if (drawer && typeof drawer.open === 'function') { try { drawer.open(); } catch (e) {} }
          }, 550);
        });
    }).catch(function () {
      button.disabled = false;
      button.classList.remove('is-busy');
      button.textContent = original;
      var err = wrap.querySelector('.on-sq-error');
      if (!err) {
        err = el('div', 'on-sq-error', self.t.cart_error);
        wrap.appendChild(err);
      }
    });
  };

  /* Sidans egen storleksguide. Blocket Storleksguide (ON) exponerar [data-sg-open],
     mini-guiden [data-sizepop]. Utan bade lank och knapp visas ingen lank alls -
     forr renderades den alltid och gjorde ingenting nar den klickades. */
  /* Bara Storleksguide (ON) - den kunden bygger sjalv i editorn. querySelector
     med en lista hade tagit den forsta i DOM-ordning, vilket kunde bli
     mini-guiden [data-sizepop]. Darfor provas selektorerna i tur och ordning. */
  var GUIDE_SELECTORS = ['[data-sg-open]', '[data-on-size-guide-trigger]'];

  Quiz.prototype.guideTrigger = function () {
    for (var i = 0; i < GUIDE_SELECTORS.length; i++) {
      var found = document.querySelector(GUIDE_SELECTORS[i]);
      if (found) return found;
    }
    return null;
  };

  Quiz.prototype.hasSizeGuide = function () {
    return !!(this.cfg.sizeGuideUrl || this.guideTrigger());
  };

  Quiz.prototype.openSizeGuide = function () {
    if (this.cfg.sizeGuideUrl) { window.location.href = this.cfg.sizeGuideUrl; return; }
    var trigger = this.guideTrigger();
    if (!trigger) return;
    this.close();
    // Guiden ar en <dialog>; ge panelens stangning en tick sa den inte staller
    // sig framfor modalen.
    setTimeout(function () { trigger.click(); }, 60);
  };

  /* "XL • 44" - samma siffra som variantknapparna visar, ur produktens egen
     tabell via on-size-secondary. Saknas siffran visas bara bokstaven. */
  Quiz.prototype.sizeLabel = function (size) {
    var rows = (this.sizeSet && this.sizeSet.sizes) || [];
    for (var i = 0; i < rows.length; i++) {
      if (normSize(rows[i].label) === normSize(size) && rows[i].secondary) {
        return size + ' • ' + rows[i].secondary;
      }
    }
    return size;
  };

  /* ---------- trigger button ---------- */

  Quiz.prototype.syncTrigger = function () {
    /* Tvafragorslaget raknar inte pa kroppsmatt och har ingen sparad profil,
       sa det finns ingen tidigare storlek att skriva in i knappen. Knappen
       heter det designen sager. */
    if (this.two) return;
    var self = this;
    var buttons = document.querySelectorAll('[data-on-sq-trigger]');
    var known = null;
    if (loadProfile() && this.stepIds.every(function (id) { return self.answers[id] != null; })) {
      var rec = recommend(this.sizeSet, this.answers);
      // Aven utanfor tabellen: knappen ska visa samma storlek som panelen gor,
      // annars sag knappen olika saker pa tva produkter for samma kund.
      if (rec) known = rec.size;
    }
    Array.prototype.forEach.call(buttons, function (b) {
      b.setAttribute('data-has-result', String(!!known));
      var label = b.querySelector('[data-on-sq-label]');
      if (!label) return;
      // Knapptexten kan vara vald i temaeditorn. Spara den serverrenderade
      // texten och atergaa till DEN, inte till standardstrangen, nar det inte
      // finns nagot resultat att visa.
      if (b.dataset.baseLabel == null) b.dataset.baseLabel = label.textContent.trim() || self.t.trigger;
      label.textContent = known ? fmt(self.t.trigger_known, { size: self.sizeLabel(known) }) : b.dataset.baseLabel;
    });
    if (known) {
      document.dispatchEvent(new CustomEvent('on:size-quiz:known', { detail: { size: known } }));
    }
  };

  /* ------------------------------------------------------------------ *
   * TVÅFRÅGORSLÄGET                                                     *
   * ------------------------------------------------------------------ *
   * EN motor, två flöden. Det här är inte en kopia av quizet utan ett
   * läge i samma fil: samma panel, samma overlay, samma Escape och samma
   * event. Config-nyckeln "mode": "two" väljer det, och den sätts bara av
   * de nya designerna. Sexstegsquizet är orört.
   *
   * Flödet är tre skärmar: fråga 1 (fyra svar), fråga 2 (två svar) och
   * resultatet. Inga mått, inga enheter, ingen sparad profil - den här
   * varianten frågar vad kunden brukar ha och hur den vill att plagget
   * sitter, och räknar inte på kroppsmått alls.
   * ------------------------------------------------------------------ */

  /* Svarsalternativen på fråga 1. Språkneutrala enligt arbetsordern:
     XS–S, M–L, XL–2XL och 3XL+ ser likadana ut på alla tolv språken. */
  var TWO_BUCKETS = [
    { id: 'xs_s', label: 'XS–S' },
    { id: 'm_l', label: 'M–L' },
    { id: 'xl_2xl', label: 'XL–2XL' },
    { id: 'xxxl', label: '3XL+' }
  ];

  /* Standardtabellen ur arbetsordern. Gäller alla produkter som inte har en
     egen tabell i metafält. */
  var TWO_TABLE = {
    xs_s: { tight: 'XS', loose: 'S' },
    m_l: { tight: 'M', loose: 'L' },
    xl_2xl: { tight: 'XL', loose: '2XL' },
    xxxl: { tight: '3XL', loose: '4XL' }
  };

  /* Storleksstegen i ordning. Används för "ett steg upp" och för att hitta
     närmast större storlek som faktiskt finns på produkten. */
  var TWO_LADDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL', '6XL'];

  /* LANGD- OCH VIKTSPANN.
     Varje alternativ har ett representativt varde som skickas in i
     berakningen. Spannen ar breda med flit: en kund vet sin langd pa
     narmaste centimeter men orkar inte leta i en lista med sextio rader,
     och skattningen tal den upplosningen - det ar omkretsarna som avgor
     storleken, och de rors knappt av fem centimeter at nagot hall. */
  var HEIGHT_STEPS = [
    { id: 'h155', cm: 156, min: null, max: 159 },
    { id: 'h165', cm: 165, min: 160, max: 169 },
    { id: 'h175', cm: 175, min: 170, max: 179 },
    { id: 'h185', cm: 185, min: 180, max: 189 },
    { id: 'h195', cm: 193, min: 190, max: null }
  ];

  var WEIGHT_STEPS = [
    { id: 'w55', kg: 56, min: null, max: 59 },
    { id: 'w67', kg: 67, min: 60, max: 74 },
    { id: 'w82', kg: 82, min: 75, max: 89 },
    { id: 'w97', kg: 97, min: 90, max: 104 },
    { id: 'w112', kg: 112, min: 105, max: 119 },
    { id: 'w128', kg: 128, min: 120, max: null }
  ];

  /* Kroppsformen oversatts till samma nycklar som sexstegsquizet anvander,
     sa SHAPE-tabellen hogre upp galler bada vagarna. */
  var SHAPE_STEPS = [
    { id: 'slim', waist: 'flat', hips: 'narrow', bust: 'small' },
    { id: 'average', waist: 'average', hips: 'average', bust: 'average' },
    { id: 'full', waist: 'round', hips: 'wide', bust: 'full' }
  ];

  /* Uppsattningarna. 'bucket' och 'fit' ar de befintliga fragorna; 'height',
     'weight' och 'shape' ar nya. Ordningen i listan ar ordningen pa skarmen. */
  var QUIZ_SETS = {
    /* Det korta quizet (omgång 58, Victor): vilken storlek du brukar ha (produktens egna
       storlekar) och hur byxan ska sitta, räknat mot tabellen (recommendShort). */
    size_fit: { steps: ['usual', 'fit3'], body: false, short: true },
    body: { steps: ['height', 'weight'], body: true },
    body_fit: { steps: ['height', 'weight', 'fit'], body: true },
    body_shape: { steps: ['height', 'weight', 'shape'], body: true },
    /* Quizuppläggen (punkt 4, Victor 2026-10-15/16). Samma motor: recommend()
       med omkretsar och benlängdens golv. Bara frågorna skiljer. */
    body_fit3: { steps: ['height', 'weight', 'fit3'], body: true },
    waist_hip: { steps: ['height', 'waist_cm', 'hip_cm'], body: true, needs: ['waist', 'hip'] },
    /* Längd och vikt ger omkretsarna som i de andra; innerbenet ersätter bara
       det golv som annars räknas fram ur längden. */
    inseam: { steps: ['height', 'weight', 'inseam_cm'], body: true, needs: ['inseam'] },
    layer: { steps: ['height', 'weight', 'layer'], body: true },
    activity: { steps: ['height', 'weight', 'activity'], body: true },
    /* "Din vanliga storlek" (omgång 49, Victor, först Warm Fleece Pants): utgår från
       storleken kunden brukar ha och går högst ett steg upp, och bara när svaren visar
       lång kropp, långa ben eller breda höfter/bred midja. Den som brukar ha S får
       aldrig L. Benlängden prövas mot tabellens innerben när den finns. */
    usual: { steps: ['usual', 'height', 'issue'], body: false, usual: true },
    /* Omgång 55 (Victor): "Vanlig storlek, benlängd och passform". Svaren byggs ur
       produktens egna storlekar (hela intervallet) och rekommendationen räknas mot
       tabellens mått (midja, höft, byst, innerben) utan stegtak: den går upp eller ner
       så långt tabellen motiverar, upp till största storleken. "Vet inte" på varje fråga.
       Benlängdsfrågan ställs bara när tabellen har innerben. */
    smart: { steps: ['usual', 'form', 'height', 'fit3'], body: false, smart: true }
  };

  /* Lager och aktivitet blir samma passformsval som resten av quizet. */
  var LAYER_FIT = { none: 'regular', base: 'layer_base', thick: 'loose' };
  var ACTIVITY_FIT = { hike: 'regular', train: 'tight', everyday: 'regular', winter: 'loose' };

  /* Tal som kunden skriver in, i cm. Utanför spannet är det ett felskrivet
     tal, inte en kropp, och då går det inte vidare. */
  var NUM_RANGE = { waist_cm: [50, 160], hip_cm: [70, 170], inseam_cm: [55, 100] };

  /* Har tabellen de mått ett upplägg kräver? Innerben räknas per storlek;
     midja/höft måste finnas både i tabellen och bland måtten som poängsätts. */
  function setUsable(sizeSet, needs) {
    var s = sizeSet && sizeSet.sizes;
    if (!s || !s.length) return false;
    var dimKeys = (sizeSet.dimensions || [{ key: 'waist' }, { key: 'hip' }]).map(function (d) { return d.key; });
    for (var n = 0; n < needs.length; n++) {
      var key = needs[n];
      if (key !== 'inseam' && dimKeys.indexOf(key) < 0) return false;
      var finns = false;
      for (var i = 0; i < s.length; i++) {
        var v = s[i][key];
        if ((typeof v === 'number' && v > 0) || (Object.prototype.toString.call(v) === '[object Array]' && v.length)) { finns = true; break; }
      }
      if (!finns) return false;
    }
    return true;
  }

  function cmToFtIn(cm) {
    var tum = Math.round(cm / 2.54);
    return Math.floor(tum / 12) + "'" + (tum % 12) + '"';
  }

  /* Etiketterna byggs ur siffrorna, inte ur sprakfilerna. "160-169 cm" ser
     likadant ut pa alla tolv sprak, precis som XS-S gor i den gamla fragan. */
  function stepLabel(steg, enhet, units) {
    var imperial = enhet === 'cm' ? units.height === 'in' : units.weight === 'lb';
    var v = function (x) {
      if (x == null) return null;
      if (!imperial) return x;
      return enhet === 'cm' ? cmToFtIn(x) : kgToLb(x);
    };
    var suffix = imperial ? (enhet === 'cm' ? '' : ' lb') : (enhet === 'cm' ? ' cm' : ' kg');
    var lo = v(steg.min), hi = v(steg.max);
    if (lo == null) return '< ' + v(steg.max + 1) + suffix;
    if (hi == null) return v(steg.min) + '+' + suffix;
    return lo + '\u2013' + hi + suffix;
  }

  /* Dugar produktens tabell till en kroppsberakning? Det kravs riktiga matt,
     inte bara storleksetiketter. Saknas de faller uppsattningen tillbaka pa
     den gamla fragan - hellre en enklare fraga an en pahittad siffra. */
  function bodyUsable(sizeSet) {
    var s = sizeSet && sizeSet.sizes;
    if (!s || !s.length) return false;
    /* Mattet ar antingen ett tal eller ett INTERVALL, [62.5, 79.3]. Forsta
       versionen godtog bara tal, och darfor foll alla produkter tillbaka pa
       den gamla fragan - aven de som har en komplett tabell. */
    var harVarde = function (v) {
      if (typeof v === 'number') return v > 0;
      if (Object.prototype.toString.call(v) === '[object Array]') {
        for (var k = 0; k < v.length; k++) if (typeof v[k] === 'number' && v[k] > 0) return true;
      }
      return false;
    };
    for (var i = 0; i < s.length; i++) {
      if (harVarde(s[i].waist) || harVarde(s[i].hip) || harVarde(s[i].bust)) return true;
    }
    return false;
  }

  /* Butiken skriver samma storlek på flera sätt. Normaliseringen gör att
     "XXL", "2 XL" och "2xl" blir samma steg i stegen ovan. */
  function twoNorm(label) {
    var s = String(label == null ? '' : label).toUpperCase().replace(/[\s._-]/g, '');
    var m = s.match(/^X{2,}L$/);
    if (m) return (s.length - 1) + 'XL';
    m = s.match(/^X{2,}S$/);
    if (m) return (s.length - 1) + 'XS';
    if (s === 'XXS') return 'XXS';
    return s;
  }

  function twoLadderIndex(label) {
    return TWO_LADDER.indexOf(twoNorm(label));
  }

  /* Produktens egna storlekar, normaliserade, med både huvudetikett och den
     sekundära (EU-numret) kvar. Den sekundära behövs för produkter vars egna
     etiketter är siffror: då står bokstaven i den kolumnen i stället. */
  function twoProductSizes(sizeSet) {
    return (sizeSet.sizes || []).map(function (s, i) {
      return {
        index: i,
        label: s.label,
        norm: twoNorm(s.label),
        secondaryNorm: s.secondary != null ? twoNorm(s.secondary) : null
      };
    });
  }

  /* Översätter en bokstavsstorlek till något produkten faktiskt säljer.
     Ordningen är arbetsorderns:
       1. exakt träff på etiketten
       2. träff via produktens sekundära kolumn (numeriska storlekar)
       3. närmast STÖRRE storlek som finns
       4. finns ingen större: den största
     Går inget av det att avgöra returneras null, och då erbjuds inte quizet
     på produkten alls - hellre ingen rekommendation än en gissad. */
  function twoResolve(sizeSet, target) {
    var sizes = twoProductSizes(sizeSet);
    if (!sizes.length) return null;
    var want = twoNorm(target);

    var exact = sizes.filter(function (s) { return s.norm === want; })[0];
    if (exact) return exact.label;

    var viaSecondary = sizes.filter(function (s) { return s.secondaryNorm === want; })[0];
    if (viaSecondary) return viaSecondary.label;

    /* Härifrån krävs att produktens storlekar går att placera i stegen.
       Skostorlekar och andra rena sifferstorlekar gör inte det, och då är
       frågan "vilken storlek brukar du ha: XS–S eller M–L" ändå meningslös. */
    var onLadder = sizes.filter(function (s) { return twoLadderIndex(s.label) > -1 || (s.secondaryNorm && twoLadderIndex(s.secondaryNorm) > -1); });
    if (!onLadder.length) return null;

    var wantIdx = TWO_LADDER.indexOf(want);
    if (wantIdx < 0) return null;

    var withIdx = onLadder.map(function (s) {
      var i = twoLadderIndex(s.label);
      if (i < 0) i = twoLadderIndex(s.secondaryNorm);
      return { label: s.label, idx: i };
    }).sort(function (a, b) { return a.idx - b.idx; });

    var larger = withIdx.filter(function (s) { return s.idx >= wantIdx; })[0];
    if (larger) return larger.label;
    return withIdx[withIdx.length - 1].label;
  }

  /* "Din vanliga storlek": produktens storlekar i ordning, vanliga storleken som golv,
     högst ett steg upp. Innerbenet i tabellen avgör längden när det finns: behovet
     skattas till 45 % av längden (samma tumregel som storleksguidens benlängdsnot) och
     paret räcker om innerbenet är högst 1 cm kortare. */
  function recommendUsual(sizeSet, a) {
    var sizes = sizeSet && sizeSet.sizes;
    if (!sizes || !sizes.length || !a.usual) return null;
    var i = -1;
    for (var k = 0; k < sizes.length; k++) if (sizes[k].label === a.usual) { i = k; break; }
    if (i < 0) {
      var lab = twoResolve(sizeSet, a.usual);
      for (var k2 = 0; k2 < sizes.length; k2++) if (sizes[k2].label === lab) { i = k2; break; }
    }
    if (i < 0) return null;
    var h = HEIGHT_STEPS.filter(function (x) { return x.id === a.height; })[0];
    var cm = h ? h.cm : null;
    var nasta = sizes[i + 1];
    var inn = function (s) { var v = s && s.inseam; return (typeof v === 'number' && v > 0) ? v : null; };
    var up = false, why = '';
    if (a.issue === 'hips' || a.issue === 'waist') { up = true; why = 'width'; }
    if (!up && nasta && cm) {
      var behov = cm * 0.45;
      var har = inn(sizes[i]);
      if (har != null) {
        /* Tabellen säger vad paret räcker till. "För korta i benen" eller lång kropp
           ger ett steg upp bara när den vanliga storleken faktiskt är för kort och
           nästa är längre. */
        if ((a.issue === 'short' || cm >= 175) && har < behov - 1 && (inn(nasta) == null || inn(nasta) > har)) { up = true; why = 'length'; }
      } else if (a.issue === 'short' && cm >= 170) {
        up = true; why = 'length';
      }
    }
    if (up && !nasta) up = false;
    var res = up ? nasta : sizes[i];
    return { size: res.label, base: sizes[i].label, up: up, why: why };
  }

  function smartHasInseam(sizeSet) {
    var s = sizeSet && sizeSet.sizes || [];
    for (var i = 0; i < s.length; i++) if (typeof s[i].inseam === 'number' && s[i].inseam > 0) return true;
    return false;
  }

  /* Kroppsformsfrågan gäller underdelar: tabellen har höft- eller midjespann men ingen byst. */
  function smartHasForm(sizeSet) {
    var keys = (sizeSet && sizeSet.dimensions || []).map(function (d) { return d.key; });
    if (keys.indexOf('bust') > -1) return false;
    var s = sizeSet && sizeSet.sizes || [];
    for (var i = 0; i < s.length; i++) {
      if ((s[i].hip && s[i].hip.length === 2) || (s[i].waist && s[i].waist.length === 2)) return true;
    }
    return false;
  }

  function smartHasHip(sizeSet) {
    var s = sizeSet && sizeSet.sizes || [];
    for (var i = 0; i < s.length; i++) if (s[i].hip && s[i].hip.length === 2) return true;
    return false;
  }

  function smartHasWaist(sizeSet) {
    var s = sizeSet && sizeSet.sizes || [];
    for (var i = 0; i < s.length; i++) if (s[i].waist && s[i].waist.length === 2) return true;
    return false;
  }

  /* Omgång 60 (Victor: 175 cm, 90 kg, lite rundare om magen, vanligen XL; quizet sa XL men
     2XL sitter bra). Midjan ska sitta bekvämt, inte på gränsen: kroppsmidjan får ligga högst
     tre fjärdedelar upp i storlekens midjespann. Med resårlinning är spannet brett
     (WFP XL 71,5–89,3 cm), så marginalen mot tabellens övre midjemått blir 4–6 cm; utan
     resår ungefär 1 cm. Gäller bara när midjan styr (Bredare midja eller midjemått). */
  var WAIST_COMFORT = 0.75;
  function waistCap(r) { return r[0] + (r[1] - r[0]) * WAIST_COMFORT; }

  /* Innerben per cm kroppslängd för längdnoten i "smart" (omgång 56). Samma kvot som
     passformsraden (on-variant-picker.js, __onFitHeight): avläst ur dagens tabeller och
     Victors uppgifter (WFP M, innerben 69 = 165–172 cm; 175 cm bär XL/2XL; modellen 165 cm
     bär XL i QuickDry). LEG_RATIO ovan hör till sexstegsquizet och lämnas orört. */
  var SMART_LEG = 0.409;

  /* Omgång 57: Mudd på sidan (stilvalet), samma ordlista som on-variant-picker.js. */
  var CUFF_RE = window.__onCuffRe || (window.__onCuffRe = /^(mudd|manchet|resori|bündchen|boord|cuffed|cuffs?|bord-côte|polsino|puño|ściągacz|punho)$/i);
  function cuffOption() {
    var b = document.querySelectorAll('.on-vp__group[data-type="other"] .on-variant-option');
    for (var i = 0; i < b.length; i++) {
      var v = String(b[i].getAttribute('data-value') || '').trim();
      if (CUFF_RE.test(v)) return { btn: b[i], name: v };
    }
    return null;
  }
  /* Quizets svar för produkten, läses av passformsraden (on-variant-picker.js). */
  function saveFit(handle, data) {
    if (!handle) return;
    try {
      var all = JSON.parse(localStorage.getItem('on_sq_fit') || '{}');
      all[handle] = data;
      var keys = Object.keys(all).sort(function (a, b) { return (all[b].ts || 0) - (all[a].ts || 0); });
      keys.slice(20).forEach(function (k) { delete all[k]; });
      localStorage.setItem('on_sq_fit', JSON.stringify(all));
    } catch (e) {}
  }

  /* Det korta quizet (omgång 58). Rymligt ger normalt en storlek upp, normal samma,
     åtsittande samma eller en mindre när tabellen motiverar det (den mindre storlekens
     spann rymmer måttet 2 cm under mitten av den vanliga storlekens spann i alla mått).
     Aldrig större än produktens största storlek; har kunden redan den sägs det ärligt. */
  function recommendShort(sizeSet, a) {
    var sizes = sizeSet && sizeSet.sizes;
    if (!sizes || !sizes.length || !a.usual) return null;
    var i = -1;
    for (var k = 0; k < sizes.length; k++) if (sizes[k].label === a.usual) { i = k; break; }
    if (i < 0) return null;
    var base = sizes[i].label;
    if (a.fit3 === 'loose') {
      if (i + 1 < sizes.length) return { size: sizes[i + 1].label, base: base, reasons: ['s_loose'] };
      return { size: base, base: base, reasons: ['s_max'] };
    }
    if (a.fit3 === 'tight' && i > 0) {
      var dims = (sizeSet.dimensions || []).filter(function (d) { return sizes[i][d.key] && sizes[i][d.key].length === 2; });
      var ner = dims.length > 0 && dims.every(function (d) {
        var r = sizes[i][d.key], m = sizes[i - 1][d.key];
        return m && m.length === 2 && m[1] >= (r[0] + r[1]) / 2 - 2;
      });
      if (ner) return { size: sizes[i - 1].label, base: base, reasons: ['s_tight_down'] };
      return { size: base, base: base, reasons: ['s_tight_same'] };
    }
    return { size: base, base: base, reasons: [a.fit3 === 'tight' ? 's_tight_same' : 's_same'] };
  }

  /* Upplägget "smart" (omgång 55, utökat omgång 56). Utgår från den vanliga storlekens mått
     i DEN HÄR produktens tabell (mitten av varje spann), lägger till passformen (åtsittande
     -2 cm, ledigt +4 cm i omkrets) och väljer storleken vars spann bäst täcker målet, vägt
     som quizets mått (dimensions).
     Kroppsform (omgång 56, Victor: en kvinna 160 cm med mycket breda höfter tyckte att 4XL
     var för trång): breda höfter +6 cm och mycket breda +12 cm på höftmålet, bredare midja
     +6 cm på midjemålet. Då avgör det måttet: storleken får aldrig vara mindre än den första
     vars spann rymmer målet, och det andra måttet räknas bara när storleken är för liten
     (resåren tar resten). Så långt tabellen motiverar, även för en kort kund.
     Höftmått (valfritt fält) går före allt annat: första storleken vars höftspann räcker.
     Längden påverkar bara om byxan blir lång eller kort: för kort innerben går uppåt så
     länge vidden sitter, för långt ger en ärlig not (byxan kan vikas upp). */
  function recommendSmart(sizeSet, a) {
    var sizes = sizeSet && sizeSet.sizes;
    if (!sizes || !sizes.length) return null;
    var inn = function (s) { var v = s && s.inseam; return (typeof v === 'number' && v > 0) ? v : null; };
    var hObj = HEIGHT_STEPS.filter(function (x) { return x.id === a.height; })[0];
    var need = hObj ? hObj.cm * SMART_LEG : null;
    /* Omgång 58: tabellens kolumn Kroppslängd (sizes[i].body = [från, till]) går före
       innerbenet, så quizet och passformsraden säger samma sak. */
    var kropp = function (s) { return s && s.body && s.body.length === 2 ? s.body : null; };
    var hcm = hObj ? hObj.cm : null;
    var langdNot = function (g, reasons) {
      var kb = kropp(sizes[g]);
      if (kb && hcm != null) { if (hcm < kb[0] - 1) reasons.push('long_note'); return; }
      var x = inn(sizes[g]);
      if (need != null && x != null && x > need + 3) reasons.push('long_note');
    };
    /* Mått (valfria fält) går före allt annat. Höft: första storleken vars höftspann räcker.
       Midja (omgång 60): första storleken där midjan ryms bekvämt (waistCap). Båda ifyllda:
       den som ger störst storlek. */
    var mH = a.hip_cm && smartHasHip(sizeSet), mW = a.waist_cm && smartHasWaist(sizeSet);
    if (mH || mW) {
      var gh = -1, gw = -1, overH = false, overW = false;
      if (mH) {
        for (var q = 0; q < sizes.length; q++) { var rq = sizes[q].hip; if (rq && rq.length === 2 && rq[1] >= a.hip_cm) { gh = q; break; } }
        if (gh < 0) { gh = sizes.length - 1; overH = true; }
      }
      if (mW) {
        for (var qw = 0; qw < sizes.length; qw++) { var rw = sizes[qw].waist; if (rw && rw.length === 2 && waistCap(rw) >= a.waist_cm) { gw = qw; break; } }
        if (gw < 0) { gw = sizes.length - 1; overW = true; }
      }
      var gm = Math.max(gh, gw);
      var rh = gw > gh ? [overW ? 'waistcm_max' : 'waistcm'] : [overH ? 'hipcm_max' : 'hipcm'];
      langdNot(gm, rh);
      return { size: sizes[gm].label, base: sizes[gm].label, fitSize: sizes[gm].label, reasons: rh, inseam: inn(sizes[gm]) };
    }
    if (!a.usual) return null;
    if (a.usual === 'unknown') return { unknown: true };
    var i = -1;
    for (var k = 0; k < sizes.length; k++) if (sizes[k].label === a.usual) { i = k; break; }
    if (i < 0) return null;
    var dims = (sizeSet.dimensions || []).filter(function (d) { return sizes[i][d.key] && sizes[i][d.key].length === 2; });
    if (!dims.length) return { size: sizes[i].label, base: sizes[i].label, reasons: ['same'] };
    var delta = a.fit3 === 'tight' ? -2 : (a.fit3 === 'loose' ? 4 : 0);
    var target = {};
    dims.forEach(function (d) { var r = sizes[i][d.key]; target[d.key] = (r[0] + r[1]) / 2 + delta; });
    /* Kroppsformen: vilket mått som styr och hur mycket. */
    var styr = null;
    if (a.form === 'hips' && target.hip != null) { target.hip += 6; styr = 'hip'; }
    else if (a.form === 'hips_xl' && target.hip != null) { target.hip += 12; styr = 'hip'; }
    else if (a.form === 'waist' && target.waist != null) { target.waist += 6; styr = 'waist'; }
    var straff = function (j) {
      var p = 0;
      dims.forEach(function (d) {
        var r = sizes[j][d.key]; if (!r || r.length !== 2) { p += 99; return; }
        var x = target[d.key];
        /* Med styrande mått räknas det andra bara när storleken är för liten. */
        if (x < r[0]) { if (!styr || d.key === styr) p += (r[0] - x) * d.weight; }
        else if (x > r[1]) p += (x - r[1]) * d.weight;
      });
      return p;
    };
    var g = i, best = straff(i);
    for (var j = 0; j < sizes.length; j++) {
      var sj = straff(j);
      if (sj < best - 1e-9 || (Math.abs(sj - best) < 1e-9 && Math.abs(j - i) < Math.abs(g - i))) { best = sj; g = j; }
    }
    var reasons = [];
    var golv = -1;
    if (styr) {
      /* Midjan med marginal (waistCap), höften mot spannets tak som förut. */
      for (var f = 0; f < sizes.length; f++) { var rf = sizes[f][styr]; if (rf && rf.length === 2 && (styr === 'waist' ? waistCap(rf) : rf[1]) >= target[styr]) { golv = f; break; } }
      if (golv < 0) golv = sizes.length - 1;
      if (g < golv) g = golv;
    }
    var fitSize = sizes[g].label;
    if (styr && g > i) reasons.push(styr === 'hip' ? 'up_hip' : 'up_waist');
    else if (g > i) reasons.push('up_fit'); else if (g < i) reasons.push('down_fit');
    /* Åtsittande: benlängden får inte ta en storlek som är vid i midja/höft. */
    var tol = a.fit3 === 'tight' ? 2 : 6;
    var ryms = function (j, upp) {
      return dims.every(function (d) { var r = sizes[j][d.key]; return r && r.length === 2 && (upp ? r[0] <= target[d.key] + tol : r[1] >= target[d.key] - 1); });
    };
    /* Benfrågan från omgång 55 (finns kvar för sparade svar) räknas om till samma behov. */
    if (need == null && inn(sizes[i]) != null && (a.legs === 'long' || a.legs === 'short')) need = inn(sizes[i]) + (a.legs === 'long' ? 3 : -2);
    if (hcm != null && kropp(sizes[g])) {
      /* Kroppslängden: för lång kund går uppåt så länge vidden sitter, annars ärlig not. */
      if (hcm > kropp(sizes[g])[1] + 1) {
        var upp = false;
        while (hcm > kropp(sizes[g])[1] + 1 && g + 1 < sizes.length && kropp(sizes[g + 1]) && ryms(g + 1, true)) { g++; upp = true; }
        if (upp) reasons.push('up_len');
        if (hcm > kropp(sizes[g])[1] + 1) reasons.push('short_len');
      } else {
        langdNot(g, reasons);
      }
    } else if (need != null && inn(sizes[g]) != null) {
      if (inn(sizes[g]) < need - 1.5) {
        var flyttad = false;
        while (inn(sizes[g]) < need - 1.5 && g + 1 < sizes.length && inn(sizes[g + 1]) > inn(sizes[g]) && ryms(g + 1, true)) { g++; flyttad = true; }
        if (flyttad) reasons.push('up_len');
        /* Fortfarande för kort: säg det ärligt (omgång 56). */
        if (inn(sizes[g]) < need - 1.5) reasons.push('short_len');
      } else {
        /* Aldrig nedåt för kort längd (§7): en för lång byxa går att vika upp, så bara noten. */
        langdNot(g, reasons);
      }
    }
    if (!reasons.length) reasons.push('same');
    return { size: sizes[g].label, base: sizes[i].label, fitSize: fitSize, reasons: reasons, inseam: inn(sizes[g]) };
  }

  /* Rekommendationen. Allt som står i arbetsorderns regeltabell, i dess ordning. */
  function recommendTwo(sizeSet, answers, cfg) {
    var bucket = answers.bucket;
    var fit = answers.fit === 'tight' ? 'tight' : 'loose';
    if (!bucket) return null;

    /* 2. Produktens egen quiztabell gäller i stället för standardtabellen.
       Formen är densamma: { "m_l": { "tight": "M", "loose": "L" }, ... } */
    var table = (cfg && cfg.quizTable && cfg.quizTable[bucket]) ? cfg.quizTable : TWO_TABLE;
    var row = table[bucket];
    if (!row) return null;
    var target = row[fit];
    if (!target) return null;

    /* 1. Produkten är märkt som liten i storleken: ett steg upp.
       Golvet gäller sedan hela vägen - resten av kedjan får aldrig hamna
       under det här steget, för notisen säger uttryckligen åt kunden att ta
       den större. */
    var bumped = false;
    if (cfg && String(cfg.sizingAdvice || '').toLowerCase().indexOf('size up') === 0) {
      var li = TWO_LADDER.indexOf(twoNorm(target));
      if (li > -1 && li < TWO_LADDER.length - 1) {
        target = TWO_LADDER[li + 1];
        bumped = true;
      }
    }

    var label = twoResolve(sizeSet, target);
    if (!label) return null;

    /* Kontrollen mot golvet: hamnade vi ändå under steget vi höjde till,
       för att produkten saknar den storleken, så är det ett fel vi hellre
       visar som "ingen rekommendation" än som en för liten storlek. */
    if (bumped) {
      var got = twoLadderIndex(label);
      var floor = TWO_LADDER.indexOf(twoNorm(target));
      if (got > -1 && floor > -1 && got < floor) return null;
    }

    return { size: label, bucket: bucket, fit: fit, bumped: bumped };
  }

  /* Finns det någon storlek alls att rekommendera? Används som gate: kan
     ingen av de åtta kombinationerna lösas ut erbjuds inte quizet. */
  function twoUsable(sizeSet, cfg) {
    for (var i = 0; i < TWO_BUCKETS.length; i++) {
      if (recommendTwo(sizeSet, { bucket: TWO_BUCKETS[i].id, fit: 'loose' }, cfg)) return true;
    }
    return false;
  }

  /* Platshållarna i språkfilerna är Shopifys dubbla klamrar, {{ size }},
     och de ska stå kvar exakt så enligt arbetsordern. fmt() ovan hanterar
     enkla klamrar, så tvåfrågorsläget har sin egen. */
  function fmt2(str, vars) {
    return String(str == null ? '' : str).replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, k) {
      return vars[k] != null ? vars[k] : '';
    });
  }

  /* ---------- skärmarna ---------- */

  /* INP (omgang 52): nasta fraga byggs efter nasta bildruta, inte i trycket (samma som nar
     quizet oppnas). Ett andra tryck innan dess raknas inte, sa ingen fraga hoppas over. */
  Quiz.prototype.renderTwoSoon = function () {
    var self = this;
    this._twoBusy = true;
    requestAnimationFrame(function () {
      setTimeout(function () { self._twoBusy = false; self.renderTwo(); }, 0);
    });
  };

  Quiz.prototype.renderTwo = function () {
    var self = this;
    this.body.innerHTML = '';
    var t = this.cfg.two || {};

    var steg = this.twoCursor;                 // sista steget = resultatet
    var antal = this.twoSteps.length;
    var frag = document.createDocumentFragment();

    var kicker = el('span', 'on-sq2__kicker');
    kicker.textContent = steg >= antal ? '' : fmt2(t.progress, { current: steg + 1, total: antal });
    if (kicker.textContent) frag.appendChild(kicker);

    /* Förloppsindikatorn. aria-hidden: siffran står redan i texten ovanför,
       så skärmläsaren ska inte läsa upp samma sak två gånger. */
    var bar = el('span', 'on-sq2__bar');
    bar.setAttribute('aria-hidden', 'true');
    var fill = el('span', 'on-sq2__fill');
    fill.style.width = Math.round(Math.min(steg + 1, antal) / antal * 100) + '%';
    bar.appendChild(fill);
    frag.appendChild(bar);

    if (steg < antal) frag.appendChild(this.twoStep(this.twoSteps[steg]));
    else frag.appendChild(this.twoResult());

    /* Tillbaka finns på fråga 2 och på resultatet. Arbetsorderns text säger
       det uttryckligen; bilderna visar ingen, men en bild som saknar något
       säger inte samma sak som en mening som kräver det. */
    if (steg > 0) {
      var back = el('button', 'on-sq2__back');
      back.type = 'button';
      back.textContent = t.back || '';
      back.addEventListener('click', function () {
        if (self._twoBusy) return;
        /* "smart" efter "Vet inte" på vanlig storlek: tillbaka till den frågan. */
        if (self.quizSet === 'smart' && self.twoAnswers.usual === 'unknown' && self.twoCursor >= self.twoSteps.length) self.twoCursor = 0;
        else {
          var bak = Math.max(0, self.twoCursor - 1);
          /* Med höftmått hoppades passformsfrågan över; tillbaka hoppar över den också. */
          while (bak > 0 && self.twoSkip(bak)) bak--;
          self.twoCursor = bak;
        }
        self.renderTwoSoon();
      });
      frag.appendChild(back);
    }

    if (this.cfg.twoNote) {
      var note = el('p', 'on-sq2__note');
      note.textContent = this.cfg.twoNote;
      frag.appendChild(note);
    }

    this.body.appendChild(frag);

    window.requestAnimationFrame(function () {
      var first = self.body.querySelector('.on-sq2__num, .on-sq2__a, .on-sq2__cta');
      if (first) first.focus();
    });
  };

  /* Omgång 56: med höftmått ifyllt räknas storleken direkt mot tabellens höft, så frågan
     om passform ställs inte. */
  Quiz.prototype.twoSkip = function (idx) {
    return this.quizSet === 'smart' && !!(this.twoAnswers.hip_cm || this.twoAnswers.waist_cm) && this.twoSteps[idx] === 'fit3';
  };
  Quiz.prototype.twoNext = function (idx) {
    var n = idx + 1;
    while (n < this.twoSteps.length && this.twoSkip(n)) n++;
    return n;
  };

  /* Kroppsformen (omgång 56): fyra kort med enkla figurer i temats linjestil, och under dem
     ett valfritt fält för höftmåttet (cm, tum i US och GB). Ett kort går vidare direkt;
     höftmåttet med Använd. Figurerna är dekoration (aria-hidden), namnet står i knappen. */
  var FORM_SVG = {
    straight: '<path d="M13 5h14M13 5c-.6 6-1 11-.6 17L14 44M27 5c.6 6 1 11 .6 17L26 44M17 44l3-17 3 17"/>',
    hips: '<path d="M14 5h12M14 5c-5 7-6 13-4 19L14 44M26 5c5 7 6 13 4 19L26 44M17 44l3-17 3 17"/>',
    hips_xl: '<path d="M14 5h12M14 5c-8 7-10 14-6 20L14 44M26 5c8 7 10 14 6 20L26 44M17 44l3-17 3 17"/>',
    waist: '<path d="M10 5h20M10 5c-2 6-1 12 2 18L14 44M30 5c2 6 1 12-2 18L26 44M17 44l3-17 3 17"/>'
  };
  Quiz.prototype.twoForm = function () {
    var self = this;
    var t = this.cfg.two || {};
    var wrap = el('div', 'on-sq2__step on-sq2__step--form');
    var h = el('h2', 'on-sq2__h');
    h.textContent = t.q_form || '';
    wrap.appendChild(h);
    var grid = el('div', 'on-sq2__grid on-sq2__grid--form');
    [['straight', t.form_straight], ['hips', t.form_hips], ['hips_xl', t.form_hips_xl], ['waist', t.form_waist]].forEach(function (o) {
      var b = el('button', 'on-sq2__a on-sq2__form on-vp__size on-szb on-szb--v2');
      b.type = 'button';
      if (self.twoAnswers.form === o[0] && !self.twoAnswers.hip_cm && !self.twoAnswers.waist_cm) b.classList.add('is-active');
      var ic = el('span', 'on-sq2__form-i', '<svg viewBox="0 0 40 48" width="30" height="36" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" focusable="false">' + FORM_SVG[o[0]] + '</svg>');
      ic.setAttribute('aria-hidden', 'true');
      b.appendChild(ic);
      var tx = el('span', 'on-sq2__form-t');
      tx.textContent = o[1] || '';
      b.appendChild(tx);
      b.addEventListener('click', function () {
        if (self._twoBusy) return;
        self.twoAnswers.form = o[0];
        delete self.twoAnswers.hip_cm;
        delete self.twoAnswers.waist_cm;
        self.twoCursor = self.twoNext(self.twoCursor);
        self.renderTwoSoon();
      });
      grid.appendChild(b);
    });
    wrap.appendChild(grid);

    /* Måtten (omgång 56 höft, omgång 60 midja): samma talfält som frågorna med tal. Varje
       fält bara när tabellen har det måttet. En Använd-knapp i sista raden tar båda; ett
       ifyllt mått räcker, båda ifyllda ger den största storleken. */
    var falt = [];
    if (this.measureFields && smartHasWaist(this.sizeSet)) falt.push({ key: 'waist_cm', label: t.waist_known });
    if (this.measureFields && smartHasHip(this.sizeSet)) falt.push({ key: 'hip_cm', label: t.hip_known });
    if (!falt.length) return wrap;
    var tum = this.units && this.units.length === 'ft';
    var use = el('button', 'on-sq2__cta on-sq2__use');
    use.type = 'button';
    use.textContent = t.hip_use || this.t.next || '';
    var err = el('p', 'on-sq2__err');
    err.setAttribute('role', 'status');
    falt.forEach(function (fa, n) {
      var r = NUM_RANGE[fa.key];
      fa.lo = tum ? Math.ceil(r[0] / 2.54) : r[0];
      fa.hi = tum ? Math.floor(r[1] / 2.54) : r[1];
      var lab = el('label', 'on-sq2__hipl');
      lab.setAttribute('for', 'on-sq2-' + fa.key);
      lab.textContent = fa.label || '';
      wrap.appendChild(lab);
      var row = el('div', 'on-sq2__numrow on-sq2__numrow--hip');
      var inp = el('input', 'on-sq2__num');
      inp.type = 'text';
      inp.id = 'on-sq2-' + fa.key;
      inp.setAttribute('inputmode', 'decimal');
      inp.setAttribute('autocomplete', 'off');
      if (self.twoAnswers[fa.key]) inp.value = String(Math.round((tum ? self.twoAnswers[fa.key] / 2.54 : self.twoAnswers[fa.key]) * 10) / 10);
      row.appendChild(inp);
      var unit = el('span', 'on-sq2__unit');
      unit.textContent = tum ? 'in' : 'cm';
      unit.setAttribute('aria-hidden', 'true');
      row.appendChild(unit);
      if (n === falt.length - 1) row.appendChild(use);
      wrap.appendChild(row);
      fa.inp = inp;
      inp.addEventListener('input', sync);
      inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); go(); } });
    });
    wrap.appendChild(err);
    /* null = tomt, false = ogiltigt, annars talet. */
    function tal(fa) {
      var raw = String(fa.inp.value).trim();
      if (raw === '') return null;
      var v = parseFloat(raw.replace(',', '.'));
      return (isFinite(v) && v >= fa.lo && v <= fa.hi) ? v : false;
    }
    function sync() {
      var ok = false, fel = false;
      falt.forEach(function (fa) { var v = tal(fa); if (v === false) fel = true; else if (v !== null) ok = true; });
      ok = ok && !fel;
      use.disabled = !ok; use.setAttribute('aria-disabled', ok ? 'false' : 'true'); if (ok) err.textContent = '';
    }
    function go() {
      if (self._twoBusy) return;
      var bad = null, any = false;
      falt.forEach(function (fa) { var v = tal(fa); if (v === false && !bad) bad = fa; else if (v !== null && v !== false) any = true; });
      if (bad) { err.textContent = fmt2(t.num_invalid, { min: bad.lo, max: bad.hi }); return; }
      if (!any) { err.textContent = ''; return; }
      falt.forEach(function (fa) { var v = tal(fa); if (v === null) delete self.twoAnswers[fa.key]; else self.twoAnswers[fa.key] = tum ? v * 2.54 : v; });
      self.twoCursor = self.twoNext(self.twoCursor);
      self.renderTwoSoon();
    }
    use.addEventListener('click', go);
    sync();
    return wrap;
  };

  /* Bygger ratt fraga for ett stegnamn. All copy kommer ur cfg.two, alltsa
     ur sprakfilerna - skriptet skriver aldrig text sjalvt, bara siffror. */
  Quiz.prototype.twoStep = function (namn) {
    var t = this.cfg.two || {};
    var u = this.units || { height: 'cm', weight: 'kg' };
    if (namn === 'height') {
      var hs = HEIGHT_STEPS.map(function (h) {
        return { value: h.id, label: stepLabel(h, 'cm', u) };
      });
      /* "smart": längden avgör bara lång/kort, så "Vet inte" går bra. Korta etiketter,
         därför två kolumner även på smal skärm (on-sq2__grid--2k). */
      if (this.quizSet === 'smart' && t.unknown) hs.push({ value: 'unknown', label: t.unknown });
      return this.twoQuestion(t.q_height, hs, 'height', this.quizSet === 'smart' ? 'on-sq2__grid--2 on-sq2__grid--2k' : 'on-sq2__grid--2');
    }
    if (namn === 'form') return this.twoForm();
    if (namn === 'weight') {
      return this.twoQuestion(t.q_weight, WEIGHT_STEPS.map(function (w) {
        return { value: w.id, label: stepLabel(w, 'kg', u) };
      }), 'weight', 'on-sq2__grid--2');
    }
    if (namn === 'shape') {
      return this.twoQuestion(t.q_shape, [
        { value: 'slim', label: t.shape_slim },
        { value: 'average', label: t.shape_average },
        { value: 'full', label: t.shape_full }
      ], 'shape', 'on-sq2__grid--2');
    }
    var smart = this.quizSet === 'smart';
    if (namn === 'fit3') {
      var f3 = [
        { value: 'tight', label: t.fit_tight },
        { value: 'regular', label: t.fit_regular },
        { value: 'loose', label: t.fit_loose }
      ];
      if (smart && t.unknown) f3.push({ value: 'unknown', label: t.unknown });
      return this.twoQuestion(t.q2, f3, 'fit3', 'on-sq2__grid--2');
    }
    if (namn === 'legs') {
      return this.twoQuestion(t.q_legs, [
        { value: 'short', label: t.legs_short },
        { value: 'avg', label: t.legs_avg },
        { value: 'long', label: t.legs_long },
        { value: 'unknown', label: t.unknown }
      ], 'legs', 'on-sq2__grid--2');
    }
    if (namn === 'layer') {
      return this.twoQuestion(t.q_layer, [
        { value: 'none', label: t.layer_none },
        { value: 'base', label: t.layer_base },
        { value: 'thick', label: t.layer_thick }
      ], 'layer', 'on-sq2__grid--2');
    }
    if (namn === 'activity') {
      return this.twoQuestion(t.q_activity, [
        { value: 'hike', label: t.act_hike },
        { value: 'train', label: t.act_train },
        { value: 'everyday', label: t.act_everyday },
        { value: 'winter', label: t.act_winter }
      ], 'activity', 'on-sq2__grid--2');
    }
    if (namn === 'usual') {
      /* Produktens egna storlekar, i tabellens ordning. */
      var us = (this.sizeSet.sizes || []).map(function (sz) {
        return { value: sz.label, label: sz.label };
      });
      if (smart && t.unknown) us.push({ value: 'unknown', label: t.unknown });
      /* "smart" gäller alla plagg: den allmänna frågan, inte "…i byxor". */
      return this.twoQuestion((smart || QUIZ_SETS[this.quizSet].short) ? (t.q1 || t.q_usual) : t.q_usual, us, 'usual', 'on-sq2__grid--4');
    }
    if (namn === 'issue') {
      return this.twoQuestion(t.q_issue, [
        { value: 'ok', label: t.issue_ok },
        { value: 'short', label: t.issue_short },
        { value: 'hips', label: t.issue_hips },
        { value: 'waist', label: t.issue_waist }
      ], 'issue', 'on-sq2__grid--2');
    }
    if (namn === 'waist_cm') return this.twoNumber(t.q_waist_cm, t.hint_waist, 'waist_cm');
    if (namn === 'hip_cm') return this.twoNumber(t.q_hip_cm, t.hint_hip, 'hip_cm');
    if (namn === 'inseam_cm') return this.twoNumber(t.q_inseam, t.hint_inseam, 'inseam_cm');
    if (namn === 'fit') {
      return this.twoQuestion(t.q2, [
        { value: 'tight', label: t.fit_tight },
        { value: 'loose', label: t.fit_loose }
      ], 'fit', 'on-sq2__grid--2');
    }
    return this.twoQuestion(t.q1, TWO_BUCKETS.map(function (b) {
      return { value: b.id, label: b.label };
    }), 'bucket', 'on-sq2__grid--4');
  };

  /* Rekommendationen for en kroppsuppsattning. Skickar vidare till SAMMA
     recommend() som sexstegsquizet: skattade omkretsar ur langd och vikt,
     poang mot produktens egen tabell, och till sist golvet for benlangden.
     Det ar det golvet som gor att 175 cm inte far en for kort byxa, och
     omkretsarna som gor att en tung kund far en storre - oberoende av
     varandra, precis som Victor beskriver fallet. */
  Quiz.prototype.recommendBody = function () {
    var a = this.twoAnswers;
    var h = HEIGHT_STEPS.filter(function (x) { return x.id === a.height; })[0];
    var w = WEIGHT_STEPS.filter(function (x) { return x.id === a.weight; })[0];
    if (!h) return null;
    var cm = h.cm;
    var measured = (a.waist_cm || a.hip_cm) ? { waist: a.waist_cm || null, hip: a.hip_cm || null } : null;
    /* Vikten frågas inte när omkretsarna är uppmätta. Den påverkar då bara
       skattningar som ersätts, så ett neutralt BMI 22 räcker. */
    var kg = w ? w.kg : (measured ? Math.round(22 * Math.pow(cm / 100, 2)) : null);
    if (!kg) return null;
    var fit = a.fit3 || (a.layer && LAYER_FIT[a.layer]) || (a.activity && ACTIVITY_FIT[a.activity]) ||
      (a.fit === 'tight' ? 'tight' : (a.fit === 'loose' ? 'loose' : 'regular'));
    var form = SHAPE_STEPS.filter(function (x) { return x.id === (a.shape || 'average'); })[0] || SHAPE_STEPS[1];
    var rec = recommend(this.sizeSet, {
      height: cm,
      weight: kg,
      measured: measured,
      legNeed: a.inseam_cm || null,
      /* Aldern fragas inte i de korta uppsattningarna. 35-44 ar mitten av
         spannet och darmed den minsta gissningen, inte den vanligaste. */
      age: '35-44',
      waist: form.waist,
      hips: form.hips,
      bust: form.bust,
      fit: fit,
      legs: 'average'
    });
    return rec ? { size: rec.size } : null;
  };

  Quiz.prototype.twoQuestion = function (heading, options, key, gridClass) {
    var self = this;
    var wrap = el('div', 'on-sq2__step');

    var h = el('h2', 'on-sq2__h');
    h.textContent = heading || '';
    wrap.appendChild(h);

    var grid = el('div', 'on-sq2__grid ' + gridClass);
    options.forEach(function (o) {
      /* Samma klasser som storleksknapparna: en delad design, inte en kopia.
         .on-vp__size + .on-szb ger exakt knapputseendet från avsnitt 1. */
      var b = el('button', 'on-sq2__a on-vp__size on-szb on-szb--v2' + (o.value === 'unknown' ? ' on-sq2__a--wide' : ''));
      b.type = 'button';
      b.textContent = o.label || '';
      b.addEventListener('click', function () {
        if (self._twoBusy) return;
        self.twoAnswers[key] = o.value;
        /* Kroppsform vald: ett tidigare höftmått gäller inte längre. */
        if (key === 'form') { delete self.twoAnswers.hip_cm; delete self.twoAnswers.waist_cm; }
        /* "smart": utan vanlig storlek finns inget att räkna på, direkt till beskedet. */
        if (self.quizSet === 'smart' && key === 'usual' && o.value === 'unknown') self.twoCursor = self.twoSteps.length;
        else self.twoCursor = self.twoNext(self.twoCursor);
        self.renderTwoSoon();
      });
      grid.appendChild(b);
    });
    wrap.appendChild(grid);
    return wrap;
  };

  /* Fråga med ett tal: midja, höft eller innerben. Tum för US och UK, cm
     annars; motorn får alltid cm. Nästa går inte att trycka förrän talet är
     rimligt, och Enter fungerar som Nästa. */
  Quiz.prototype.twoNumber = function (heading, hint, key) {
    var self = this;
    var t = this.cfg.two || {};
    var tum = this.units && this.units.length === 'ft';
    var r = NUM_RANGE[key];
    var lo = tum ? Math.ceil(r[0] / 2.54) : r[0];
    var hi = tum ? Math.floor(r[1] / 2.54) : r[1];
    var wrap = el('div', 'on-sq2__step');

    var h = el('h2', 'on-sq2__h');
    h.textContent = heading || '';
    wrap.appendChild(h);

    var id = 'on-sq2-num-' + key;
    if (hint) {
      var p = el('p', 'on-sq2__hint');
      p.id = id + '-hint';
      p.textContent = hint;
      wrap.appendChild(p);
    }

    var row = el('div', 'on-sq2__numrow');
    var inp = el('input', 'on-sq2__num');
    /* text + inputmode, inte type=number: Firefox ger ett tomt värde för
       "82,5" i ett talfält, och då fick kunden ett felbesked utan förklaring. */
    inp.type = 'text';
    inp.id = id;
    inp.setAttribute('inputmode', 'decimal');
    inp.setAttribute('autocomplete', 'off');
    inp.setAttribute('aria-label', heading || '');
    if (hint) inp.setAttribute('aria-describedby', id + '-hint');
    if (this.twoAnswers[key]) {
      var prev = this.twoAnswers[key];
      inp.value = String(Math.round((tum ? prev / 2.54 : prev) * 10) / 10);
    }
    row.appendChild(inp);
    var unit = el('span', 'on-sq2__unit');
    unit.textContent = tum ? 'in' : 'cm';
    unit.setAttribute('aria-hidden', 'true');
    row.appendChild(unit);
    wrap.appendChild(row);

    var err = el('p', 'on-sq2__err');
    err.setAttribute('role', 'status');
    wrap.appendChild(err);

    var next = el('button', 'on-sq2__cta on-sq2__next');
    next.type = 'button';
    next.textContent = this.t.next || '';
    wrap.appendChild(next);

    function tal() {
      var v = parseFloat(String(inp.value).replace(',', '.'));
      return (isFinite(v) && v >= lo && v <= hi) ? v : null;
    }
    /* Felbeskedet visas först när kunden lämnar fältet eller försöker gå
       vidare, inte mitt i skrivandet ("10" på väg mot 105). */
    function visaFel() {
      err.textContent = (tal() === null && String(inp.value).trim() !== '') ? fmt2(t.num_invalid, { min: lo, max: hi }) : '';
    }
    function sync() {
      var ok = tal() !== null;
      next.disabled = !ok;
      next.setAttribute('aria-disabled', ok ? 'false' : 'true');
      if (ok) err.textContent = '';
    }
    function go() {
      if (self._twoBusy) return;
      var v = tal();
      if (v === null) { visaFel(); return; }
      self.twoAnswers[key] = tum ? v * 2.54 : v;
      self.twoCursor = self.twoCursor + 1;
      self.renderTwoSoon();
    }
    inp.addEventListener('input', sync);
    inp.addEventListener('blur', visaFel);
    inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); go(); } });
    next.addEventListener('click', go);
    sync();
    return wrap;
  };

  Quiz.prototype.twoResult = function () {
    var self = this;
    var t = this.cfg.two || {};
    var wrap = el('div', 'on-sq2__result');

    var rec = QUIZ_SETS[this.quizSet].short
      ? recommendShort(this.sizeSet, this.twoAnswers)
      : QUIZ_SETS[this.quizSet].smart
      ? recommendSmart(this.sizeSet, this.twoAnswers)
      : QUIZ_SETS[this.quizSet].usual
      ? recommendUsual(this.sizeSet, this.twoAnswers)
      : (QUIZ_SETS[this.quizSet].body
        ? this.recommendBody()
        : recommendTwo(this.sizeSet, this.twoAnswers, this.cfg));
    if (rec && rec.unknown) {
      /* Utan den vanliga storleken finns inget att räkna från: hänvisa till måtten. */
      var unk = el('p', 'on-sq2__miss');
      unk.textContent = t.r_unknown || this.t.out_of_range || '';
      wrap.appendChild(unk);
      return wrap;
    }
    if (!rec) {
      /* Ingen storlek gick att lösa ut. Hellre en ärlig återvändsgränd än en
         gissad storlek som ger en retur. */
      var miss = el('p', 'on-sq2__miss');
      miss.textContent = this.t.out_of_range || '';
      wrap.appendChild(miss);
      return wrap;
    }

    /* Omgång 57: svaren sparas för passformsraden. Blir byxan lång och produkten har Mudd
       rekommenderas Mudd (och väljs när kunden tar förslaget). */
    var rs = rec.reasons || [];
    var cuff = cuffOption();
    var hStep = HEIGHT_STEPS.filter(function (x) { return x.id === self.twoAnswers.height; })[0];
    this.twoFit = {
      s: rec.size,
      h: hStep ? hStep.cm : null,
      form: this.twoAnswers.form || null,
      long: rs.indexOf('long_note') > -1,
      short: rs.indexOf('short_len') > -1,
      cuff: !!(cuff && rs.indexOf('long_note') > -1),
      ts: Date.now()
    };
    saveFit(this.cfg.handle, this.twoFit);

    var ring = el('span', 'on-sq2__ring', ICON_CHECK);
    ring.setAttribute('aria-hidden', 'true');
    wrap.appendChild(ring);

    var lab = el('p', 'on-sq2__label');
    lab.textContent = t.result_label || '';
    wrap.appendChild(lab);

    var size = el('p', 'on-sq2__size');
    /* "2XL • 34": bokstaven plus produktens egen EU/UK/US-siffra, samma
       sifferkolumn som storleksknapparna och sexstegsquizet visar. Saknar
       tabellen den kolumnen star bara bokstaven kvar.
       Knappen under behaller den rena bokstaven - "Välj 2XL • 34 och
       fortsätt" lases inte som en storlek utan som tva. */
    size.textContent = this.sizeLabel(rec.size);
    wrap.appendChild(size);

    /* "Din vanliga storlek": en rad om varför, så kunden ser att förslaget utgår från
       hennes egen storlek. */
    if (rec.reasons) {
      /* "smart": kort varför, ur tabellens egna siffror. */
      var tum = this.units && this.units.length === 'ft';
      var innTxt = rec.inseam != null ? (tum ? (Math.round(rec.inseam / 2.54 * 10) / 10) + ' in' : rec.inseam + ' cm') : '';
      rec.reasons.slice(0, 3).forEach(function (r) {
        var tx = t['r_' + r];
        if (r === 'long_note' && cuff && t.r_long_cuff) tx = fmt2(t.r_long_cuff, { cuff: cuff.name });
        if (!tx) return;
        var p = el('p', 'on-sq2__why');
        /* Passformsraden nämner storleken passformen gav, benlängdsraden slutstorleken. */
        var sz = (r === 'up_fit' || r === 'down_fit') ? (rec.fitSize || rec.size) : rec.size;
        var matt = function (v) { return v ? (tum ? (Math.round(v / 2.54 * 10) / 10) + ' in' : Math.round(v) + ' cm') : ''; };
        p.textContent = fmt2(tx, { size: sz, usual: rec.base, inseam: innTxt, hip: matt(self.twoAnswers.hip_cm), waist: matt(self.twoAnswers.waist_cm) });
        wrap.appendChild(p);
      });
    } else if (rec.base) {
      var why = el('p', 'on-sq2__why');
      why.textContent = !rec.up ? (t.usual_same || '') : (rec.why === 'width' ? (t.usual_up_width || '') : (t.usual_up_len || ''));
      if (why.textContent) wrap.appendChild(why);
    }

    var cta = el('button', 'on-sq2__cta');
    cta.type = 'button';
    cta.textContent = fmt2(t.result_cta, { size: rec.size });
    cta.addEventListener('click', function () { self.twoPick(rec.size); });
    wrap.appendChild(cta);

    /* Beskedet till skärmläsaren ligger färdigt men tomt, och fylls först när
       kunden valt. En live-region som redan har text vid rendering läses upp
       i fel ögonblick. */
    this.twoLive = el('p', 'on-sq2__live');
    this.twoLive.setAttribute('role', 'status');
    this.twoLive.setAttribute('aria-live', 'polite');
    wrap.appendChild(this.twoLive);

    return wrap;
  };

  /* "Välj M och fortsätt". Storleken ska bli vald på riktigt - variant-id,
     pris, lagerstatus och URL - inte bara se vald ut. */
  Quiz.prototype.twoPick = function (label) {
    var t = this.cfg.two || {};
    var valt = this.twoApply(label);
    /* Omgång 57: lång byxa och Mudd finns: välj Mudd om den inte redan är vald. */
    if (this.twoFit && this.twoFit.cuff) {
      setTimeout(function () { var c = cuffOption(); if (c && !c.btn.classList.contains('is-active')) c.btn.click(); }, 160);
    }

    if (this.twoLive) this.twoLive.textContent = fmt2(t.result_selected, { size: label });

    /* Samma event som sexstegsläget skickar, så analys och snippetens egen
       fallback-markering fortsätter fungera oförändrat. */
    document.dispatchEvent(new CustomEvent('on:size-quiz:result', {
      detail: { size: label, alternative: null, measurements: null, mode: 'two' }
    }));

    var self = this;
    setTimeout(function () {
      self.close();
      self.twoCloseGuide();
      self.twoFocusBuy();
    }, valt ? 120 : 0);
  };

  /* Klick på den riktiga storleksknappen är det enda som driver hela kedjan:
     variantväljarens egen kod talar om för Shopifys motor vilken variant som
     gäller, och den uppdaterar pris, lager och URL. Att sätta en klass hade
     bara sett rätt ut. Slutsåld storlek väljs också - den vanliga
     slutsåld-hanteringen tar över därifrån. */
  Quiz.prototype.twoApply = function (label) {
    var esc = window.CSS && CSS.escape ? CSS.escape(label) : String(label).replace(/"/g, '\\"');
    var btn = document.querySelector('.on-vp__group[data-type="size"] .on-vp__size[data-value="' + esc + '"]');
    if (btn) { btn.click(); return true; }
    var radio = document.querySelector('form[action*="/cart/add"] input[type="radio"][value="' + esc + '"]');
    if (radio && !radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }
    return false;
  };

  /* Startades quizet inifran storleksguiden star guiden kvar oppen nar quizet
     stangs, och den ar en <dialog> som haller kvar fokus. Kunden har da valt sin
     storlek men stannar i mattabellen i stallet for vid kopknappen. Guiden ska
     stangas med quizet - men BARA om den ar oppen, sa inget annat rors. */
  Quiz.prototype.twoCloseGuide = function () {
    var oppna = document.querySelectorAll('dialog.on-sg__dialog[open]');
    Array.prototype.forEach.call(oppna, function (d) {
      var x = d.querySelector('[data-sg-close]');
      if (x) { x.click(); return; }
      try { d.close(); } catch (e) {}
    });
  };

  Quiz.prototype.twoFocusBuy = function () {
    var buy = document.querySelector('.add-to-cart-button:not(.sticky-add-to-cart__button), button[name="add"]:not(.sticky-add-to-cart__button)');
    if (!buy) return;
    var r = buy.getBoundingClientRect();
    var syns = r.top >= 0 && r.bottom <= (window.innerHeight || 0);
    if (!syns) {
      try { buy.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { buy.scrollIntoView(); }
    }
    try { buy.focus({ preventScroll: true }); } catch (e) { buy.focus(); }
  };

  /* Fokusfälla. Bara i tvåfrågorsläget: sexstegsquizet ska bete sig exakt som
     förut. Tab och Shift+Tab stannar i panelen så länge den är öppen. */
  Quiz.prototype.twoTrapFocus = function (e) {
    if (e.key !== 'Tab') return;
    if (this.panel.getAttribute('data-open') !== 'true') return;
    var f = this.panel.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    var synliga = Array.prototype.filter.call(f, function (n) { return !n.disabled && n.offsetParent !== null; });
    if (!synliga.length) return;
    var first = synliga[0], last = synliga[synliga.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  };

  /* ------------------------------------------------------------------ *
   * Boot                                                                *
   * ------------------------------------------------------------------ */
  var OnSizeQuiz = {
    instance: null,
    init: function (config) {
      if (!config || !config.sizeSet || !config.sizeSet.sizes || !config.sizeSet.sizes.length) {
        console.warn('[on-size-quiz] missing size chart for this product, quiz not mounted');
        return null;
      }
      if (config.mode === 'two' && config.quizSet !== 'smart' && !twoUsable(config.sizeSet, config)) {
        /* Produktens storlekar gar inte att placera i XS..6XL och har ingen
           bokstavskolumn att oversatta via - rena skostorlekar till exempel.
           Da ar fragan "vilken storlek brukar du ha: XS-S eller M-L" ocksa
           meningslos. Hellre ingen knapp an en knapp som gissar. */
        console.warn('[on-size-quiz] tvafragorslaget kan inte losa ut nagon storlek for den har produkten, visas inte');
        /* Motorn gommer BARA snippetens egen knapp. Vad andra ytor har att
           erbjuda i stallet vet de sjalva battre - variantvaljaren har en
           storleksguide som ska bli kvar nar quizet forsvinner. Darfor ett
           besked i stallet for en bred doljning. */
        Array.prototype.forEach.call(document.querySelectorAll('.on-sq-trigger'), function (n) {
          n.setAttribute('hidden', '');
        });
        document.dispatchEvent(new CustomEvent('on:size-quiz:unavailable'));
        return null;
      }
      var quiz = new Quiz(config);
      this.instance = quiz;
      return quiz;
    },

    /* Ingen bindning per knapp langre - se delegeringen langst ned. Kvar som
       anrop sa aldre kod som ropar pa den inte kraschar. */
    bind: function () {},
    // exposed for tuning and for unit tests
    estimateBody: estimateBody,
    recommend: recommend,
    recommendTwo: recommendTwo,
    twoResolve: twoResolve,
    clearProfile: clearProfile,
    getProfile: loadProfile
  };

  window.OnSizeQuiz = OnSizeQuiz;

  /* EN DELEGERAD LYSSNARE, I CAPTURE-FASEN. Inga lyssnare per knapp.

     Varfor: en knapp som renderats om ar en NY nod utan lyssnare. I
     temaeditorn ritas sektionen om vid varje installningsandring, och da
     slutade quizknappen fungera efter forsta andringen. Matt, inte gissat.

     Forsta forsoket band om knapparna och satte ett marke i dataset for att
     slippa dubbla lyssnare. Det gjorde saken varre: cloneNode kopierar
     attributet men INTE lyssnaren, sa en omritad knapp bar market "redan
     bunden" utan att vara det, och delegeringen hoppade over just den.
     Market ar borta. En enda lyssnare galler alla knappar, nu och senare.

     Capture-fasen, inte bubbling: ett lager som stoppar klickets bubbling (en
     <dialog>, en modal) gor annars att document aldrig ser klicket. I capture
     gar handelsen uppifran och ned och hinner fram forst. */
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-on-sq-trigger]') : null;
    if (!t) return;
    /* INP (omgang 52): quizet byggs efter nasta bildruta, inte i trycket. Byggt i trycket
       lamnade det layouten smutsig for spararna som lyssnar pa samma klick efter oss
       (Meta-pixeln mater sidan), och tillsammans tog trycket 650-890 ms pa mobil. */
    requestAnimationFrame(function () {
      setTimeout(function () { if (OnSizeQuiz.instance) OnSizeQuiz.instance.open(); }, 0);
    });
  }, true);

})(window, document);
